(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
(() => {
  const start = root => {
    if (root.benefitsCleanup) root.benefitsCleanup();
    const all = [...root.querySelectorAll('[data-benefit-item]')];
    const viewport = root.querySelector('[data-benefit-viewport]');
    const next = root.querySelector('[data-benefit-next]');
    const prev = root.querySelector('[data-benefit-prev]');
    const pause = root.querySelector('[data-benefit-pause]');
    const count = root.querySelector('[data-benefit-count]');
    const status = root.querySelector('[data-benefit-status]');
    const mobile = matchMedia('(max-width:749px)');
    const reduced = matchMedia('(prefers-reduced-motion:reduce)');
    const abort = new AbortController();
    const signal = abort.signal;
    let items = [], index = 0, timer, paused = false, hovering = false, focused = false, touchX = null, suppressClick = false;
    const clear = () => { clearTimeout(timer); timer = null; };
    const staticMode = () => !mobile.matches && root.dataset.desktopMode === 'static';
    const schedule = () => {
      clear();
      if (items.length < 2 || paused || hovering || focused || document.hidden || reduced.matches || staticMode() || root.dataset.autoplay !== 'true' || window.Shopify?.designMode) return;
      timer = setTimeout(() => { show(index + 1, false); }, Number(root.dataset.interval) || 5000);
    };
    const show = (position, announce = false) => {
      if (!items.length) return;
      index = (position + items.length) % items.length;
      all.forEach(item => {
        const current = item === items[index] || (staticMode() && items.includes(item));
        item.classList.add('is-ready');
        item.classList.toggle('is-current', current);
        item.setAttribute('aria-hidden', String(!current));
        item.inert = !current;
      });
      count.textContent = `${String(index + 1).padStart(2,'0')} / ${String(items.length).padStart(2,'0')}`;
      if (announce) status.textContent = items[index].querySelector(mobile.matches ? '.lion-benefits__mobile-text' : '.lion-benefits__desktop-text').textContent;
      schedule();
    };
    const sync = () => {
      const current = items[index];
      items = all.filter(item => !mobile.matches || !item.classList.contains('lion-benefits__item--desktop-only'));
      root.classList.toggle('is-static', staticMode());
      prev.disabled = next.disabled = items.length < 2;
      if (items.length < 2) root.classList.add('is-single'); else root.classList.remove('is-single');
      index = Math.max(0, items.indexOf(current));
      show(index);
      root.hidden = items.length === 0;
    };
    const go = direction => show(index + direction, true);
    prev.addEventListener('click', () => go(-1), {signal});
    next.addEventListener('click', () => go(1), {signal});
    pause.addEventListener('click', () => {
      paused = !paused;
      pause.setAttribute('aria-pressed', String(paused));
      pause.setAttribute('aria-label', paused ? pause.dataset.playLabel : pause.dataset.pauseLabel);
      schedule();
    }, {signal});
    root.addEventListener('mouseenter', () => { if (root.dataset.pauseHover === 'true') { hovering = true; clear(); } }, {signal});
    root.addEventListener('mouseleave', () => { hovering = false; schedule(); }, {signal});
    root.addEventListener('focusin', () => { focused = true; clear(); }, {signal});
    root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) { focused = false; schedule(); } }, {signal});
    root.addEventListener('keydown', event => { if (staticMode() || !['ArrowLeft','ArrowRight'].includes(event.key)) return; event.preventDefault(); go(event.key === 'ArrowRight' ? 1 : -1); }, {signal});
    viewport.addEventListener('touchstart', event => { touchX = event.touches[0].clientX; suppressClick = false; clear(); }, {signal,passive:true});
    viewport.addEventListener('touchend', event => { const delta = touchX === null ? 0 : event.changedTouches[0].clientX - touchX; touchX = null; if (Math.abs(delta) > 35) { suppressClick = true; go(delta < 0 ? 1 : -1); } else schedule(); }, {signal,passive:true});
    viewport.addEventListener('touchcancel', () => {touchX = null; schedule();}, {signal,passive:true});
    viewport.addEventListener('click', event => { if (suppressClick) { event.preventDefault(); suppressClick = false; } }, {signal});
    document.addEventListener('visibilitychange', schedule, {signal});
    document.addEventListener('shopify:block:select', event => {
      const selected = items.findIndex(item => item.dataset.blockId === event.detail?.blockId);
      if (selected >= 0) { paused = true; show(selected); }
    }, {signal});
    mobile.addEventListener('change', sync, {signal});
    reduced.addEventListener('change', schedule, {signal});
    root.benefitsCleanup = () => { clear(); abort.abort(); };
    sync();
  };
  const initialize = scope => scope.querySelectorAll('[data-lion-benefits]').forEach(start);
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-lion-benefits]').forEach(root => root.benefitsCleanup?.()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-campaign"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('campaign-countdown')) {
    class CampaignCountdown extends HTMLElement {
      connectedCallback() {
        this.timer = this.querySelector('[data-countdown-timer]');
        this.expired = this.querySelector('[data-countdown-expired]');
        this.status = this.querySelector('[data-countdown-status]');
        this.deadlineLabel = this.querySelector('[data-countdown-deadline]');
        const deadlineValue = (this.dataset.deadline || '').trim();
        const explicitZone = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/;
        this.deadline = explicitZone.test(deadlineValue) ? new Date(deadlineValue) : new Date(Number.NaN);
        this.hasAnnouncedInitial = false;
        this.announcedThresholds = new Set();
        this.update = this.update.bind(this);
        this.renderDeadline();
        this.update();
        if (!this.hasAttribute('data-expired') && !this.hasAttribute('data-invalid')) this.interval = window.setInterval(this.update, 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
      }

      format(value) {
        return String(value).padStart(2, '0');
      }

      setValue(name, value) {
        const node = this.querySelector(`[data-countdown-${name}]`);
        if (node) node.textContent = this.format(value);
      }

      renderDeadline() {
        if (!this.deadlineLabel || !Number.isFinite(this.deadline.getTime())) return;
        try {
          this.deadlineLabel.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'es-PE', {
            dateStyle: 'long',
            timeStyle: 'short'
          }).format(this.deadline);
        } catch (error) {
          this.deadlineLabel.textContent = this.dataset.deadline;
        }
      }

      showInvalid() {
        window.clearInterval(this.interval);
        this.setAttribute('data-invalid', '');
        if (this.timer) this.timer.hidden = true;
        if (this.expired) {
          this.expired.hidden = false;
          const message = this.expired.querySelector('p');
          if (message) message.textContent = this.dataset.invalidLabel || '';
        }
        if (this.status) this.status.textContent = this.dataset.invalidLabel || '';
      }

      showExpired() {
        window.clearInterval(this.interval);
        this.setAttribute('data-expired', '');
        if (this.timer) this.timer.hidden = true;
        if (this.expired) this.expired.hidden = false;
        if (this.status) this.status.textContent = this.dataset.expiredLabel || '';
      }

      update() {
        if (!Number.isFinite(this.deadline.getTime())) {
          this.showInvalid();
          return;
        }

        const remaining = this.deadline.getTime() - Date.now();
        if (remaining <= 0) {
          this.showExpired();
          return;
        }

        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        this.setValue('days', days);
        this.setValue('hours', hours);
        this.setValue('minutes', minutes);
        this.setValue('seconds', seconds);

        const totalMinutes = Math.floor(remaining / 60000);
        const announcementThresholds = [1440, 60, 10, 5, 1];
        const threshold = announcementThresholds.find((value) => totalMinutes === value);
        if (this.status && (!this.hasAnnouncedInitial || (threshold && !this.announcedThresholds.has(threshold)))) {
          this.hasAnnouncedInitial = true;
          if (threshold) this.announcedThresholds.add(threshold);
          this.status.textContent = `${this.dataset.activeLabel}: ${days} ${this.dataset.daysLabel}, ${hours} ${this.dataset.hoursLabel}, ${minutes} ${this.dataset.minutesLabel}`;
        }
      }
    }

    customElements.define('campaign-countdown', CampaignCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ll-header')) {
    customElements.define('ll-header', class extends HTMLElement {
      connectedCallback() {
        if (this.lifecycleController) return;
        this.lifecycleController = new AbortController();
        const signal = this.lifecycleController.signal;
        this.mobileDialog = this.querySelector('[data-mobile-menu-dialog]');
        this.mobileNavBody = this.mobileDialog?.querySelector('.ll-nav-mobile__body');
        this.searchDialog = this.querySelector('[data-search-dialog]');
        this.mobileOpenButton = this.querySelector('[data-mobile-menu-open]');
        this.searchOpenButton = this.querySelector('[data-search-open]');
        this.mobileSearchButton = this.querySelector('[data-mobile-search-open]');
        this.headerWrapper = this.closest('[id^="shopify-section-"]');
        this.headerWrapper?.toggleAttribute('data-header', this.dataset.sticky === 'true');
        this.scrollTicking = false;

        this.onScroll = this.onScroll.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);

        this.mobileOpenButton?.addEventListener('click', () => this.openHeaderDialog(this.mobileDialog, this.mobileOpenButton), { signal });
        this.searchOpenButton?.addEventListener('click', () => this.openHeaderDialog(this.searchDialog, this.searchOpenButton), { signal });
        this.mobileSearchButton?.addEventListener('click', (event) => {
          event.preventDefault();
          const openSearch = () => {
            this.searchDialog?.addEventListener('close', () => this.mobileOpenButton?.focus({ preventScroll: true }), { once: true, signal });
            this.openHeaderDialog(this.searchDialog, this.mobileSearchButton);
          };
          if (this.mobileDialog?.open && window.LionTheme?.closeDialog) {
            this.mobileDialog.addEventListener('close', openSearch, { once: true, signal });
            window.LionTheme.closeDialog(this.mobileDialog, false);
          } else {
            openSearch();
          }
        }, { signal });

        this.querySelectorAll('[data-mega-menu]').forEach((details) => {
          details.addEventListener('toggle', () => {
            if (details.open) this.openMega(details);
          }, { signal });
          details.querySelector(':scope > summary > span')?.addEventListener('pointerenter', (event) => {
            if (event.pointerType !== 'mouse' || !window.matchMedia('(min-width: 1100px) and (hover: hover)').matches) return;
            this.openMega(details);
          }, { signal });
        });

        const desktopNav = this.querySelector('.ll-desktop-nav');
        desktopNav?.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'mouse' || !window.matchMedia('(min-width: 1100px) and (hover: hover)').matches) return;
          this.querySelectorAll('[data-mega-menu][open]').forEach((details) => details.removeAttribute('open'));
        }, { signal });

        this.addEventListener('click', (event) => {
          const link = event.target.closest('[data-mobile-menu-dialog] a[href], [data-mega-menu] a[href]');
          if (!link) return;
          const destination = new URL(link.href, window.location.href);
          if (destination.origin !== window.location.origin || destination.pathname !== window.location.pathname || !destination.hash) return;
          const target = document.getElementById(destination.hash.slice(1));
          if (!target) return;
          event.preventDefault();
          const goToSection = () => {
            window.location.hash = destination.hash;
            target.scrollIntoView({ block: 'start', behavior: 'instant' });
          };
          this.querySelectorAll('[data-mega-menu][open]').forEach((details) => details.removeAttribute('open'));
          if (this.mobileDialog?.open && window.LionTheme?.closeDialog) {
            this.mobileDialog.addEventListener('close', goToSection, { once: true, signal });
            window.LionTheme.closeDialog(this.mobileDialog, false);
          } else {
            if (this.mobileDialog?.open) this.mobileDialog.close();
            goToSection();
          }
        }, { signal });

        window.addEventListener('scroll', this.onScroll, { passive: true, signal });
        document.addEventListener('click', this.onDocumentClick, { signal });
        document.addEventListener('keydown', this.onKeydown, { signal });
        this.updateScrolledState();
        window.LionTheme?.initialize?.(document);
      }

      disconnectedCallback() {
        this.lifecycleController?.abort();
        this.lifecycleController = null;
        this.headerWrapper?.removeAttribute('data-header');
      }

      onScroll() {
        if (this.scrollTicking) return;
        this.scrollTicking = true;
        requestAnimationFrame(() => {
          this.updateScrolledState();
          this.scrollTicking = false;
        });
      }

      updateScrolledState() {
        this.classList.toggle('is-scrolled', window.scrollY > 12);
      }

      openMega(target) {
        this.querySelectorAll('[data-mega-menu][open]').forEach((details) => {
          if (details !== target) details.removeAttribute('open');
        });
        target.setAttribute('open', '');
      }

      onDocumentClick(event) {
        if (this.contains(event.target)) return;
        this.querySelectorAll('[data-mega-menu][open]').forEach((details) => details.removeAttribute('open'));
      }

      onKeydown(event) {
        if (event.key !== 'Escape') return;
        const openMega = this.querySelector('[data-mega-menu][open]');
        if (openMega) {
          openMega.removeAttribute('open');
          openMega.querySelector('summary')?.focus();
        }
      }

      openHeaderDialog(dialog, trigger) {
        if (!dialog) return;
        if (dialog === this.mobileDialog) {
          this.querySelectorAll('.ll-mobile-nav__details[open]').forEach((details) => details.removeAttribute('open'));
          if (this.mobileNavBody) this.mobileNavBody.scrollTop = 0;
        }
        if (window.LionTheme?.openDialog) {
          window.LionTheme.openDialog(dialog, trigger);
          return;
        }
        if (!dialog.open) dialog.showModal();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lion-category-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lion-category-finder')) {
  class LionCategoryFinder extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.frame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      if (!this.isConnected || !this.controller) return;
      const signal = this.controller.signal;
      this.tabs = Array.from(this.querySelectorAll('[data-tabs] [data-tab][role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel][role="tabpanel"]'));
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.activePanel = null;
      this.tracks = new Map();
      this.observer = new ResizeObserver(() => this.scheduleUpdate());

      this.panels.forEach(panel => {
        const track = panel.querySelector('[data-track]');
        if (!track) return;
        const state = {
          track,
          cards: Array.from(track.querySelectorAll('[data-card]')),
          previous: panel.querySelector('[data-prev]'),
          next: panel.querySelector('[data-next]'),
          position: panel.querySelector('[data-position]')
        };
        this.tracks.set(panel, state);
        this.observer.observe(track);
        state.cards.forEach(card => this.observer.observe(card));
        track.addEventListener('scroll', () => this.scheduleUpdate(), { passive: true, signal });
        track.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          if (event.target !== track) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.move(panel, event.key === 'ArrowRight' ? 1 : -1);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.scrollTo(track, event.key === 'Home' ? 0 : track.scrollWidth - track.clientWidth);
          }
        }, { signal });
        state.previous?.addEventListener('click', () => this.move(panel, -1), { signal });
        state.next?.addEventListener('click', () => this.move(panel, 1), { signal });
      });

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(tab, true), { signal });
        tab.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          let nextIndex;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = this.tabs.length - 1;
          else return;
          event.preventDefault();
          const nextTab = this.tabs[nextIndex];
          this.activate(nextTab, true);
          nextTab.focus({ preventScroll: true });
        }, { signal });
      });

      document.addEventListener('shopify:block:select', event => {
        const blockId = event.detail?.blockId;
        const block = blockId
          ? Array.from(this.querySelectorAll('[data-block-id]')).find(item => item.dataset.blockId === String(blockId))
          : null;
        const panel = block?.closest('[data-panel][role="tabpanel"]');
        const tab = this.tabs.find(item => item.dataset.panel === panel?.id);
        if (tab) this.activate(tab, false);
      }, { signal });

      const initial = this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
      if (initial) this.activate(initial, false);
      this.dataset.ready = '';
      this.scheduleUpdate();
    }

    activate(tab, reveal) {
      const panel = this.panels.find(item => item.id === tab.dataset.panel);
      if (!panel) return;
      const changed = this.activePanel !== panel;
      const hadActivePanel = Boolean(this.activePanel);
      this.tabs.forEach(item => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach(item => { item.hidden = item !== panel; });
      this.activePanel = panel;
      if (changed && hadActivePanel) {
        this.tracks.get(panel)?.track.scrollTo({ left: 0, behavior: 'instant' });
      }
      if (reveal) {
        tab.scrollIntoView({
          block: 'nearest',
          inline: 'nearest',
          behavior: this.motion.matches ? 'auto' : 'smooth'
        });
      }
      const count = this.tracks.get(panel)?.cards.length || 0;
      const results = panel.querySelector('[data-results]');
      if (results) results.textContent = (results.dataset.template || '[count] modelos para ti').replace('[count]', String(count));
      this.scheduleUpdate();
    }

    move(panel, direction) {
      const state = this.tracks.get(panel);
      if (!state || !state.cards.length) return;
      const current = state.track.scrollLeft;
      const trackBounds = state.track.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(state.track).paddingLeft) || 0;
      const starts = state.cards.map(card => card.getBoundingClientRect().left - trackBounds.left + current - padding);
      let destination;
      if (direction > 0) destination = starts.find(start => start > current + 3);
      else destination = starts.slice().reverse().find(start => start < current - 3);
      this.scrollTo(state.track, destination ?? (direction > 0 ? state.track.scrollWidth - state.track.clientWidth : 0));
    }

    scrollTo(track, destination) {
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      track.scrollTo({
        left: Math.max(0, Math.min(maximum, destination)),
        behavior: this.motion.matches ? 'auto' : 'smooth'
      });
      this.scheduleUpdate();
    }

    scheduleUpdate() {
      if (this.updateFrame || !this.controller) return;
      this.updateFrame = requestAnimationFrame(() => {
        this.updateFrame = null;
        this.update();
      });
    }

    update() {
      const state = this.tracks?.get(this.activePanel);
      if (!state) return;
      const maximum = Math.max(0, state.track.scrollWidth - state.track.clientWidth);
      const current = state.track.scrollLeft;
      if (state.previous) state.previous.disabled = current <= 2;
      if (state.next) state.next.disabled = maximum <= 2 || current >= maximum - 2;
      const bounds = state.track.getBoundingClientRect();
      const visible = [];
      state.cards.forEach((card, index) => {
        const rectangle = card.getBoundingClientRect();
        const visibleWidth = Math.max(0, Math.min(rectangle.right, bounds.right) - Math.max(rectangle.left, bounds.left));
        if (visibleWidth >= rectangle.width / 2) visible.push(index + 1);
      });
      const first = visible[0] || (state.cards.length ? 1 : 0);
      const last = visible[visible.length - 1] || first;
      if (state.position) state.position.textContent = `${first === last ? first : `${first}–${last}`} / ${state.cards.length}`;
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.updateFrame);
      this.controller = null;
      this.updateFrame = null;
      this.activePanel = null;
      this.tracks = null;
      delete this.dataset.ready;
    }
  }

  customElements.define('lion-category-finder', LionCategoryFinder);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lion-combo-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lion-combo-finder')) {
  class LionComboFinder extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.frame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      if (!this.isConnected || !this.controller) return;
      const signal = this.controller.signal;
      this.tabs = Array.from(this.querySelectorAll('[data-tabs] [data-tab][role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel][role="tabpanel"]'));
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.activePanel = null;
      this.tracks = new Map();
      this.observer = new ResizeObserver(() => this.scheduleUpdate());

      this.panels.forEach(panel => {
        const track = panel.querySelector('[data-track]');
        if (!track) return;
        const state = {
          track,
          cards: Array.from(track.querySelectorAll('[data-card]')),
          previous: panel.querySelector('[data-prev]'),
          next: panel.querySelector('[data-next]'),
          navigation: panel.querySelector('.lco__navigation')
        };
        this.tracks.set(panel, state);
        this.observer.observe(track);
        state.cards.forEach(card => this.observer.observe(card));
        track.addEventListener('scroll', () => this.scheduleUpdate(), { passive: true, signal });
        track.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          if (event.target !== track) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.move(panel, event.key === 'ArrowRight' ? 1 : -1);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.scrollTo(track, event.key === 'Home' ? 0 : track.scrollWidth - track.clientWidth);
          }
        }, { signal });
        state.previous?.addEventListener('click', () => this.move(panel, -1), { signal });
        state.next?.addEventListener('click', () => this.move(panel, 1), { signal });
      });

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(tab, true), { signal });
        tab.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          let nextIndex;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = this.tabs.length - 1;
          else return;
          event.preventDefault();
          const nextTab = this.tabs[nextIndex];
          this.activate(nextTab, true);
          nextTab.focus({ preventScroll: true });
        }, { signal });
      });

      document.addEventListener('shopify:block:select', event => {
        const blockId = event.detail?.blockId;
        const block = blockId
          ? Array.from(this.querySelectorAll('[data-block-id]')).find(item => item.dataset.blockId === String(blockId))
          : null;
        const panel = block?.closest('[data-panel][role="tabpanel"]');
        const tab = this.tabs.find(item => item.dataset.panel === panel?.id);
        if (tab) this.activate(tab, false);
      }, { signal });

      this.addEventListener('click', event => {
        const link = event.target.closest?.('a[href]');
        if (!link || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        if (link.target === '_blank' || link.origin !== location.origin) return;
        this.rememberNavigation();
      }, { capture: true, signal });
      window.addEventListener('pagehide', () => this.rememberNavigation(), { signal });
      window.addEventListener('pageshow', () => this.scheduleUpdate(), { signal });

      if (!this.restoreNavigation()) {
        const initial = this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
        if (initial) this.activate(initial, false);
      }
      this.dataset.ready = '';
      this.scheduleUpdate();
    }

    readNavigation() {
      const saved = history.state?.lionComboFinder?.[this.id];
      return saved?.path === location.pathname + location.search ? saved : null;
    }

    rememberNavigation() {
      if (!this.activePanel) return;
      const track = this.tracks?.get(this.activePanel)?.track;
      if (!track) return;
      const previous = history.state;
      if (previous !== null && (typeof previous !== 'object' || Array.isArray(previous))) return;
      const sectionStates = previous?.lionComboFinder;
      try {
        history.replaceState({
          ...previous,
          lionComboFinder: {
            ...(sectionStates && typeof sectionStates === 'object' ? sectionStates : {}),
            [this.id]: {
              path: location.pathname + location.search,
              panel: this.activePanel.id,
              left: track.scrollLeft,
              railLeft: this.querySelector('[data-tabs]')?.scrollLeft || 0
            }
          }
        }, '', location.href);
      } catch {}
    }

    restoreNavigation() {
      const saved = this.readNavigation();
      const tab = this.tabs?.find(item => item.dataset.panel === saved?.panel);
      if (!tab) return false;
      this.activate(tab, false, true);
      const track = this.tracks?.get(this.activePanel)?.track;
      if (track) {
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        const left = Math.max(0, Math.min(maximum, Number(saved.left) || 0));
        if (Math.abs(track.scrollLeft - left) > 1) track.scrollLeft = left;
      }
      const rail = this.querySelector('[data-tabs]');
      const railLeft = Math.max(0, Number(saved.railLeft) || 0);
      if (rail && Math.abs(rail.scrollLeft - railLeft) > 1) rail.scrollLeft = railLeft;
      this.scheduleUpdate();
      return true;
    }

    activate(tab, reveal, restoring = false) {
      const panel = this.panels.find(item => item.id === tab.dataset.panel);
      if (!panel) return;
      const changed = this.activePanel !== panel;
      const hadActivePanel = Boolean(this.activePanel);
      this.tabs.forEach(item => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach(item => { item.hidden = item !== panel; });
      this.activePanel = panel;
      if (changed && hadActivePanel && !restoring) {
        this.tracks.get(panel)?.track.scrollTo({ left: 0, behavior: 'instant' });
      }
      if (reveal) {
        const rail = tab.parentElement;
        const delta = tab.offsetLeft - rail.offsetLeft - (rail.clientWidth - tab.offsetWidth) / 2;
        rail.scrollTo({ left: Math.max(0, delta), behavior: this.motion.matches ? 'auto' : 'smooth' });
      }
      this.scheduleUpdate();
    }

    move(panel, direction) {
      const state = this.tracks.get(panel);
      if (!state || !state.cards.length) return;
      const current = state.track.scrollLeft;
      const trackBounds = state.track.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(state.track).paddingLeft) || 0;
      const starts = state.cards.map(card => card.getBoundingClientRect().left - trackBounds.left + current - padding);
      let destination;
      if (direction > 0) destination = starts.find(start => start > current + 3);
      else destination = starts.slice().reverse().find(start => start < current - 3);
      this.scrollTo(state.track, destination ?? (direction > 0 ? state.track.scrollWidth - state.track.clientWidth : 0));
    }

    scrollTo(track, destination) {
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      track.scrollTo({
        left: Math.max(0, Math.min(maximum, destination)),
        behavior: this.motion.matches ? 'auto' : 'smooth'
      });
      this.scheduleUpdate();
    }

    scheduleUpdate() {
      if (this.updateFrame || !this.controller) return;
      this.updateFrame = requestAnimationFrame(() => {
        this.updateFrame = null;
        this.update();
      });
    }

    update() {
      const state = this.tracks?.get(this.activePanel);
      if (!state) return;
      const maximum = Math.max(0, state.track.scrollWidth - state.track.clientWidth);
      const current = state.track.scrollLeft;
      const carousel = state.track.parentElement;
      const image = state.cards[0]?.querySelector('.lco__image-link');
      if (carousel && image) {
        const imageBounds = image.getBoundingClientRect();
        const carouselBounds = carousel.getBoundingClientRect();
        carousel.style.setProperty('--lco-arrow-top', `${imageBounds.top - carouselBounds.top + imageBounds.height / 2}px`);
      }
      if (state.navigation) state.navigation.hidden = maximum <= 2;
      if (state.previous) state.previous.disabled = current <= 2;
      if (state.next) state.next.disabled = maximum <= 2 || current >= maximum - 2;
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.updateFrame);
      this.controller = null;
      this.updateFrame = null;
      this.activePanel = null;
      this.tracks = null;
      delete this.dataset.ready;
    }
  }

  customElements.define('lion-combo-finder', LionComboFinder);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lion-google-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lion-google-reviews')) {
    customElements.define('lion-google-reviews', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.resize?.disconnect();
        this.visibility?.disconnect();
        cancelAnimationFrame(this.frame);
        delete this.dataset.enhanced;
        this.events = new AbortController();
        const signal = this.events.signal;
        this.track = this.querySelector('[data-reviews-track]');
        if (!this.track) return;
        const enhance = () => {
          if (signal.aborted || this.dataset.enhanced === 'true') return;
          this.visibility?.disconnect();
          this.visibility = null;
          this.enhance(signal);
        };
        if (window.Shopify?.designMode || typeof IntersectionObserver === 'undefined') {
          enhance();
          return;
        }
        this.visibility = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) enhance();
        }, {rootMargin:'600px 0px'});
        this.visibility.observe(this);
        this.addEventListener('focusin', enhance, {once:true,signal});
        this.addEventListener('pointerdown', enhance, {once:true,signal});
      }
      enhance(signal) {
        this.cards = Array.from(this.track.querySelectorAll('[data-review-block]'));
        this.controls = this.querySelector('[data-reviews-controls]');
        this.previous = this.querySelector('[data-review-step="-1"]');
        this.next = this.querySelector('[data-review-step="1"]');
        this.position = this.querySelector('[data-reviews-position]');
        this.dialog = this.querySelector('[data-reviews-dialog]');
        this.fullPhoto = this.querySelector('[data-reviews-full-photo]');
        this.addEventListener('error', event => {
          const avatar = event.target;
          if (avatar instanceof HTMLImageElement && avatar.matches('[data-review-avatar]')) avatar.hidden = true;
        }, {capture:true,signal});
        this.querySelectorAll('[data-review-avatar]').forEach(avatar => {
          if (avatar.complete && avatar.naturalWidth === 0) avatar.hidden = true;
        });
        this.addEventListener('click', event => {
          const expand = event.target.closest('[data-review-expand]');
          if (expand) {
            const card = expand.closest('[data-review-block]');
            if (card) {
              const expanded = expand.getAttribute('aria-expanded') !== 'true';
              card.classList.toggle('is-expanded', expanded);
              expand.setAttribute('aria-expanded', String(expanded));
              expand.textContent = expanded ? expand.dataset.labelLess : expand.dataset.labelMore;
            }
          }
          const arrow = event.target.closest('[data-review-step]');
          if (arrow && !arrow.disabled) this.move(Number(arrow.dataset.reviewStep));
          const photo = event.target.closest('[data-review-photo]');
          if (photo && this.dialog?.showModal && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
            event.preventDefault();
            this.fullPhoto.src = matchMedia('(max-width:749px)').matches && photo.dataset.mobilePhotoUrl ? photo.dataset.mobilePhotoUrl : photo.href;
            this.fullPhoto.alt = photo.dataset.photoAlt || '';
            this.dialog.showModal();
          }
        }, {signal});
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, {passive:true,signal});
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.track.scrollTo({left:event.key === 'Home' ? 0 : this.track.scrollWidth,behavior:this.behavior()});
          }
        }, {signal});
        document.addEventListener('shopify:block:select', event => {
          if (event.detail?.sectionId !== this.dataset.sectionId) return;
          const card = this.cards.find(item => item.dataset.reviewBlock === event.detail.blockId);
          card?.scrollIntoView({block:'nearest',inline:'start',behavior:'auto'});
        }, {signal});
        this.dialog?.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }, {signal});
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.dataset.enhanced = 'true';
        this.update();
      }
      disconnectedCallback() {
        this.events?.abort();
        this.resize?.disconnect();
        this.visibility?.disconnect();
        delete this.dataset.enhanced;
        cancelAnimationFrame(this.frame);
        if (this.dialog?.open) this.dialog.close();
      }
      behavior() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
      move(direction) {
        const card = this.cards[0];
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({left:direction * (card.getBoundingClientRect().width + gap),behavior:this.behavior()});
      }
      update() {
        if (!this.cards.length || !this.controls) return;
        const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
        this.controls.hidden = !overflow;
        const frame = this.track.getBoundingClientRect();
        const firstBox = this.cards[0].getBoundingClientRect();
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = firstBox.width + gap;
        const firstCenter = firstBox.left + firstBox.width / 2;
        let start = 0;
        let end = this.cards.length - 1;
        if (step > 0 && firstBox.width > 0 && Number.isFinite(firstCenter)) {
          start = Math.max(0, Math.floor((frame.left - firstCenter) / step) - 1);
          end = Math.min(end, Math.ceil((frame.right - firstCenter) / step) + 1);
        }
        let firstVisible = -1;
        let lastVisible = -1;
        for (let index = start; index <= end; index += 1) {
          const box = index === 0 ? firstBox : this.cards[index].getBoundingClientRect();
          const center = box.left + box.width / 2;
          if (center >= frame.left && center <= frame.right) {
            if (firstVisible === -1) firstVisible = index;
            lastVisible = index;
          }
        }
        const from = (firstVisible === -1 ? 0 : firstVisible) + 1;
        const to = lastVisible === -1 ? from : lastVisible + 1;
        this.previous.disabled = !overflow || this.track.scrollLeft <= 2;
        this.next.disabled = !overflow || this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
        const template = from === to ? this.position.dataset.single : this.position.dataset.range;
        const label = template.replaceAll('__FROM__',String(from)).replaceAll('__TO__',String(to)).replaceAll('__TOTAL__',String(this.cards.length));
        if (this.position.textContent !== label) this.position.textContent = label;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lion-launch-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lion-launch-gallery')) {
  class LionLaunchGallery extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.initializeFrame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      if (!this.isConnected || !this.controller) return;
      this.track = this.querySelector('[data-lnl-track]');
      if (!this.track) return;
      this.filters = Array.from(this.querySelectorAll('[data-lnl-filter]'));
      this.cards = Array.from(this.track.querySelectorAll('[data-lnl-card]'));
      this.previous = this.querySelector('[data-lnl-prev]');
      this.next = this.querySelector('[data-lnl-next]');
      this.navigation = this.querySelector('[data-lnl-nav]');
      this.status = this.querySelector('[data-lnl-status]');
      this.desktop = window.matchMedia('(min-width: 750px)');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const signal = this.controller.signal;

      this.filters.forEach(filter => filter.addEventListener('click', () => {
        if (!this.isDisabled(filter)) this.applyFilter(filter.dataset.filter || 'all');
      }, { signal }));
      this.cards.forEach(card => {
        card.querySelectorAll('[data-lnl-swatch]').forEach(swatch => {
          swatch.addEventListener('click', () => {
            if (!this.isDisabled(swatch)) this.selectSwatch(card, swatch);
          }, { signal });
        });
      });
      this.previous?.addEventListener('click', () => {
        if (!this.isDisabled(this.previous)) this.move(-1);
      }, { signal });
      this.next?.addEventListener('click', () => {
        if (!this.isDisabled(this.next)) this.move(1);
      }, { signal });
      this.track.addEventListener('scroll', () => this.scheduleUpdate(), { passive: true, signal });
      this.desktop.addEventListener('change', () => {
        if (!this.desktop.matches) this.track.scrollTo({ left: 0, behavior: 'instant' });
        this.scheduleUpdate();
      }, { signal });
      this.observer = new ResizeObserver(() => this.scheduleUpdate());
      this.observer.observe(this.track);
      this.cards.forEach(card => this.observer.observe(card));

      document.addEventListener('shopify:block:select', event => {
        const blockId = event.detail?.blockId;
        if (!blockId) return;
        const block = Array.from(this.querySelectorAll('[data-block-id]')).find(item => item.dataset.blockId === String(blockId));
        const card = block?.matches('[data-lnl-card]') ? block : block?.closest('[data-lnl-card]');
        if (!card || !this.cards.includes(card)) return;
        if (card.hidden) this.applyFilter('all');
        if (!this.desktop.matches) return;
        const frame = requestAnimationFrame(() => {
          this.blockFrames.delete(frame);
          if (!this.controller || !this.isConnected) return;
          const bounds = this.track.getBoundingClientRect();
          const rectangle = card.getBoundingClientRect();
          let destination = this.track.scrollLeft;
          if (rectangle.left < bounds.left) destination += rectangle.left - bounds.left;
          else if (rectangle.right > bounds.right) destination += rectangle.right - bounds.right;
          this.scrollTo(destination);
        });
        this.blockFrames.add(frame);
      }, { signal });

      this.blockFrames = new Set();
      this.applyFilter(this.filters.find(filter => filter.getAttribute('aria-pressed') === 'true' && !this.isDisabled(filter))?.dataset.filter || 'all', false);
      this.dataset.ready = '';
    }

    isDisabled(button) {
      return !button || button.disabled || button.getAttribute('aria-disabled') === 'true';
    }

    applyFilter(value, reset = true) {
      const valid = value === 'all' || this.filters.some(filter => filter.dataset.filter === value && !this.isDisabled(filter));
      const category = valid ? value : 'all';
      this.filters.forEach(filter => filter.setAttribute('aria-pressed', String((filter.dataset.filter || 'all') === category)));
      this.cards.forEach(card => { card.hidden = category !== 'all' && card.dataset.category !== category; });
      if (reset) this.track.scrollTo({ left: 0, behavior: 'instant' });
      if (this.status) {
        const count = this.cards.filter(card => !card.hidden).length;
        this.status.textContent = (this.status.dataset.countTemplate || '{count} modelos').replaceAll('{count}', String(count));
      }
      this.scheduleUpdate();
    }

    selectSwatch(card, swatch) {
      const values = swatch.dataset;
      card.querySelectorAll('[data-lnl-swatch]').forEach(button => button.setAttribute('aria-pressed', String(button === swatch)));
      if (values.url) card.querySelectorAll('[data-lnl-link]').forEach(link => link.setAttribute('href', values.url));
      if (values.price !== undefined) {
        const price = card.querySelector('[data-lnl-price]');
        if (price) price.textContent = values.price;
      }
      if (values.compare !== undefined) {
        const compare = card.querySelector('[data-lnl-compare]');
        if (compare) {
          compare.textContent = values.compare;
          compare.hidden = !values.compare.trim();
        }
      }
      if (values.image) {
        const image = card.querySelector('[data-lnl-image]');
        if (image) {
          if (values.srcset) image.setAttribute('srcset', values.srcset);
          else image.removeAttribute('srcset');
          image.setAttribute('src', values.image);
          if (values.alt !== undefined) image.setAttribute('alt', values.alt);
        }
      }
      if (values.label !== undefined) {
        const color = card.querySelector('[data-lnl-color]');
        if (color) color.textContent = values.label;
      }
    }

    move(direction) {
      if (!this.desktop.matches) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.scrollTo(this.track.scrollLeft + direction * (this.track.clientWidth + gap));
    }

    scrollTo(destination) {
      this.track.scrollTo({
        left: Math.max(0, Math.min(Math.max(0, this.track.scrollWidth - this.track.clientWidth), destination)),
        behavior: this.motion.matches ? 'auto' : 'smooth'
      });
      this.scheduleUpdate();
    }

    scheduleUpdate() {
      if (this.updateFrame || !this.controller) return;
      this.updateFrame = requestAnimationFrame(() => {
        this.updateFrame = null;
        if (!this.controller || !this.track) return;
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const overflow = this.desktop.matches && maximum > 2;
        if (this.navigation) this.navigation.hidden = !overflow;
        if (this.previous) this.previous.disabled = !overflow || this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = !overflow || this.track.scrollLeft >= maximum - 2;
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.initializeFrame);
      cancelAnimationFrame(this.updateFrame);
      this.blockFrames?.forEach(frame => cancelAnimationFrame(frame));
      this.controller = null;
      this.updateFrame = null;
      this.track = null;
      delete this.dataset.ready;
    }
  }

  customElements.define('lion-launch-gallery', LionLaunchGallery);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lion-radian-assurance"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lion-trust-center')) {
    customElements.define('lion-trust-center', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.captureQuestionState();
        if (this.questionOrigins) this.restoreQuestions();
        this.events = new AbortController();
        const signal = this.events.signal;
        this.questions = Array.from(this.querySelectorAll('[data-trust-question]'));
        this.groups = Array.from(this.querySelectorAll('[data-trust-group]'));
        this.questionOrigins = new Map(this.questions.map(question => [question,question.parentElement]));
        this.grid = this.querySelector('.ltc-grid');
        this.search = this.querySelector('[data-trust-search]');
        this.input = this.querySelector('[data-trust-input]');
        this.clear = this.querySelector('[data-trust-clear]');
        this.empty = this.querySelector('[data-trust-empty]');
        this.status = this.querySelector('[data-trust-status]');
        this.mobileShell = this.querySelector('[data-trust-mobile]');
        this.intents = this.querySelector('[data-trust-intents]');
        this.routes = this.querySelector('[data-trust-routes]');
        this.routeButtons = Array.from(this.querySelectorAll('[data-trust-route]'));
        this.routePanels = Array.from(this.querySelectorAll('[data-trust-panel]'));
        this.view = this.querySelector('[data-trust-view]');
        this.viewTitle = this.querySelector('[data-trust-view-title]');
        this.viewDescription = this.querySelector('[data-trust-view-description]');
        this.mobileFooter = this.querySelector('[data-trust-mobile-footer]');
        this.contact = this.querySelector('[data-trust-mobile-contact]');
        this.contactLabel = this.querySelector('[data-trust-mobile-cta]');
        this.contactNote = this.querySelector('[data-trust-mobile-note]');
        this.searchText = new Map(this.questions.map(question => [question,this.normalize(question.textContent)]));
        this.topicQuestionStates = this.topicQuestionStates || new Map();
        this.questionRoutes = new Map(this.questions.map(question => [question,this.getQuestionRoutes(question)]));
        this.mobile = window.matchMedia('(max-width:749px)');
        this.mode = this.mode === 'order' ? 'order' : 'buy';
        this.expandedRoutes = this.expandedRoutes || {buy:new Set(),order:new Set()};
        this.activeRoutes = this.activeRoutes || {buy:null,order:null};
        this.questionLayout = null;
        this.dataset.mobileReady = 'true';
        this.routeButtons.forEach(button => {
          button.dataset.available = String(this.questions.some(question => this.questionRoutes.get(question).includes(button.dataset.trustRoute)));
        });
        this.input?.addEventListener('input', () => this.render(), {signal});
        this.addEventListener('click', event => {
          if (!(event.target instanceof Element)) return;
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.matches('[data-trust-clear],[data-trust-reset]')) {
            if (this.input) this.input.value = '';
            this.render();
            this.input?.focus({preventScroll:true});
          } else if (button.dataset.trustMode) {
            this.mode = button.dataset.trustMode;
            if (this.input) this.input.value = '';
            this.render();
          } else if (button.dataset.trustRoute) {
            this.toggleTopic(button);
          }
        }, {signal});
        this.mobile.addEventListener('change', () => {
          this.updatePlaceholder();
        }, {signal});
        document.addEventListener('shopify:block:select', event => {
          if (String(event.detail?.sectionId) !== this.dataset.sectionId) return;
          const question = this.questions.find(item => item.dataset.blockId === String(event.detail.blockId));
          if (!question) return;
          if (this.input) this.input.value = '';
          {
            const allowed = this.questionRoutes.get(question);
            const route = this.routeButtons.find(button => button.dataset.routeMode === this.mode && allowed.includes(button.dataset.trustRoute)) || this.routeButtons.find(button => allowed.includes(button.dataset.trustRoute));
            if (route) {
              this.mode = route.dataset.routeMode;
              this.expandedRoutes[this.mode].add(route.dataset.trustRoute);
              this.activeRoutes[this.mode] = route.dataset.trustRoute;
            }
          }
          this.render();
          question.open = true;
        }, {signal});
        if (this.search && this.input) this.search.hidden = false;
        this.render();
      }
      disconnectedCallback() {
        this.captureQuestionState();
        this.events?.abort();
      }
      normalize(value) { return String(value).normalize('NFD').replace(/\p{M}/gu,'').toLowerCase().replace(/\s+/g,' ').trim(); }
      getQuestionRoutes(question) {
        const known = {
          faq_measure:['size'],faq_materials:['materials'],faq_water:['materials'],faq_sensitive_skin:['materials'],faq_magnetic:['materials'],
          faq_shipping:['delivery'],faq_express:['delivery'],faq_tracking:['delivery','tracking'],
          faq_payment:['payment'],faq_installments:['payment'],faq_offer:['payment'],
          faq_changes:['changes','exchange'],faq_issue:['issue'],faq_store:['store'],faq_packaging:['store']
        };
        const allowed = this.routeButtons.map(button => button.dataset.trustRoute);
        const custom = (question.dataset.mobileTopics || '').split(',').map(value => value.trim()).filter(value => allowed.includes(value));
        if (custom.length) return custom;
        if (known[question.dataset.blockId]) return known[question.dataset.blockId];
        const category = question.closest('[data-trust-group]')?.dataset.category;
        return category === 'envios' ? ['delivery'] : category === 'pagos' ? ['payment'] : category === 'cambios' ? ['changes','exchange'] : ['materials'];
      }
      captureQuestionState() {
        if (!this.questions || !this.topicQuestionStates || (this.questionLayout !== 'buy' && this.questionLayout !== 'order')) return;
        this.routePanels.forEach(panel => {
          const questions = Array.from(panel.querySelectorAll('[data-trust-question]'));
          if (!questions.length) return;
          const state = this.topicQuestionStates.get(panel.dataset.trustPanel) || new Map();
          questions.forEach(question => state.set(question.dataset.blockId,question.open));
          this.topicQuestionStates.set(panel.dataset.trustPanel,state);
        });
      }
      restoreQuestions() {
        const nextByOrigin = new Map();
        for (let index = this.questions.length - 1; index >= 0; index -= 1) {
          const question = this.questions[index];
          const origin = this.questionOrigins.get(question);
          if (!origin) continue;
          const next = nextByOrigin.get(origin) || null;
          if (question.parentElement !== origin || question.nextElementSibling !== next) origin.insertBefore(question,next);
          nextByOrigin.set(origin,question);
        }
      }
      placeQuestions(layout) {
        if (this.questionLayout === layout) return;
        this.captureQuestionState();
        const searchState = new Map(this.questions.map(question => [question,question.open]));
        this.restoreQuestions();
        this.questions.forEach(question => {
          question.hidden = false;
          question.open = layout === 'search' && searchState.get(question) || false;
        });
        if (layout === 'buy' || layout === 'order') {
          const buttons = this.routeButtons.filter(button => button.dataset.routeMode === layout);
          this.questions.forEach(question => {
            const route = buttons.find(button => this.questionRoutes.get(question).includes(button.dataset.trustRoute));
            const panel = route && this.routePanels.find(item => item.dataset.trustPanel === route.dataset.trustRoute);
            panel?.appendChild(question);
          });
          buttons.forEach(button => {
            const id = button.dataset.trustRoute;
            const panel = this.routePanels.find(item => item.dataset.trustPanel === id);
            const questions = Array.from(panel?.querySelectorAll('[data-trust-question]') || []);
            if (!this.topicQuestionStates.has(id)) this.topicQuestionStates.set(id,new Map(questions.map((question,index) => [question.dataset.blockId,index === 0])));
            const state = this.topicQuestionStates.get(id);
            questions.forEach(question => { question.open = state.get(question.dataset.blockId) || false; });
          });
        }
        this.questionLayout = layout;
      }
      filterQuestions(test) {
        let count = 0;
        this.questions.forEach(question => {
          const match = test(question);
          question.hidden = !match;
          if (match) count += 1;
        });
        this.groups.forEach(group => { group.hidden = !Array.from(group.querySelectorAll('[data-trust-question]')).some(question => !question.hidden); });
        return count;
      }
      toggleTopic(button) {
        const id = button.dataset.trustRoute;
        if (button.dataset.routeMode !== this.mode || this.questionLayout !== this.mode) return;
        const panel = this.routePanels.find(item => item.dataset.trustPanel === id);
        if (!panel || !panel.querySelector('[data-trust-question]')) return;
        const expanded = this.expandedRoutes[this.mode];
        const open = !expanded.has(id);
        if (open) expanded.add(id);
        else expanded.delete(id);
        button.setAttribute('aria-expanded',String(open));
        panel.hidden = !open;
        this.activeRoutes[this.mode] = open ? id : Array.from(expanded).pop() || null;
        this.updateMobileStatus();
      }
      updateMobileStatus() {
        const expanded = this.expandedRoutes[this.mode];
        const count = this.routePanels.reduce((total,panel) => total + (expanded.has(panel.dataset.trustPanel) && !panel.hidden ? panel.querySelectorAll('[data-trust-question]').length : 0),0);
        if (this.status) this.status.textContent = count ? this.status.dataset.label.replace('__COUNT__',String(count)) : this.querySelector('[data-trust-mode="'+this.mode+'"]')?.textContent || '';
        const route = this.routeButtons.find(button => button.dataset.trustRoute === this.activeRoutes[this.mode] && expanded.has(button.dataset.trustRoute));
        this.updateContact(route);
      }
      updateContact(route) {
        if (!this.mobileFooter) return;
        const data = this.mobileFooter.dataset;
        const isOrder = this.mode === 'order';
        const label = route?.dataset.routeCta || (isOrder ? data.orderCta : data.buyCta);
        const message = route?.dataset.routeMessage || (isOrder ? data.orderMessage : data.buyMessage);
        if (this.contactLabel) this.contactLabel.textContent = label || '';
        if (this.contactNote) this.contactNote.textContent = route || isOrder ? data.helpNote : data.buyNote;
        if (this.contact) {
          try {
            const url = new URL(this.dataset.waUrl);
            url.searchParams.set('text',message || '');
            this.contact.href = url.href;
          } catch {
            this.contact.href = this.dataset.waUrl || '#';
          }
        }
        this.mobileFooter.hidden = !this.contact || !label;
      }
      updatePlaceholder() {
        if (this.input) this.input.placeholder = this.mobile.matches ? this.input.dataset.mobilePlaceholder : this.input.dataset.desktopPlaceholder;
      }
      render() {
        const query = this.normalize(this.input?.value || '');
        const words = query ? query.split(' ') : [];
        const matching = question => words.every(word => this.searchText.get(question).includes(word));
        if (this.clear) this.clear.hidden = !(this.input?.value);
        this.updatePlaceholder();
        if (this.mobileShell) this.mobileShell.hidden = false;
        this.querySelectorAll('[data-trust-mode]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.trustMode === this.mode)));
        if (this.intents) this.intents.hidden = false;
        if (this.routes) this.routes.hidden = Boolean(query);
        if (this.view) this.view.hidden = !query;
        if (query) {
          this.placeQuestions('search');
          const count = this.filterQuestions(matching);
          if (this.grid) this.grid.hidden = count === 0;
          if (this.empty) this.empty.hidden = count > 0;
          if (this.viewTitle) this.viewTitle.textContent = count === 1 ? this.viewTitle.dataset.resultsOne : this.viewTitle.dataset.resultsMany.replace('__COUNT__',String(count));
          if (this.viewDescription) this.viewDescription.textContent = this.viewDescription.dataset.searchIntro;
          if (count === 1) this.questions.find(question => !question.hidden)?.setAttribute('open','');
          if (this.status) this.status.textContent = this.status.dataset.label.replace('__COUNT__',String(count));
          this.updateContact(null);
          return;
        }
        this.placeQuestions(this.mode);
        this.questions.forEach(question => { question.hidden = false; });
        if (this.grid) this.grid.hidden = true;
        if (this.empty) this.empty.hidden = true;
        this.routeButtons.forEach(button => {
          const panel = this.routePanels.find(item => item.dataset.trustPanel === button.dataset.trustRoute);
          const available = button.dataset.available === 'true' && Boolean(panel?.querySelector('[data-trust-question]'));
          const hidden = button.dataset.routeMode !== this.mode || !available;
          button.closest('[data-trust-topic]').hidden = hidden;
          button.hidden = hidden;
          const open = !hidden && this.expandedRoutes[this.mode].has(button.dataset.trustRoute);
          button.setAttribute('aria-expanded',String(open));
          if (panel) panel.hidden = !open;
        });
        this.updateMobileStatus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lion-radian-visit"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('lion-simple-map')) return;

  let sdkPromise;
  let authHookInstalled = false;
  const authFailures = new Set();

  function installAuthHook() {
    if (authHookInstalled) return;
    const previous = window.gm_authFailure;
    window.gm_authFailure = () => {
      for (const callback of authFailures) callback();
      if (typeof previous === 'function') {
        try { previous(); } catch (_) {}
      }
    };
    authHookInstalled = true;
  }

  function loadMaps(key) {
    installAuthHook();
    if (window.google && window.google.maps && window.google.maps.Map && window.google.maps.OverlayView) {
      return Promise.resolve(window.google.maps);
    }
    if (sdkPromise) return sdkPromise;
    sdkPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const callbackName = '__lionSimpleMapReady' + Date.now().toString(36);
      let settled = false;
      const finish = (error) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        delete window[callbackName];
        script.onerror = null;
        if (error) {
          script.remove();
          reject(error);
        } else {
          resolve(window.google.maps);
        }
      };
      const timer = setTimeout(() => finish(new Error('Maps timeout')), 20000);
      window[callbackName] = () => {
        if (window.google && window.google.maps && window.google.maps.Map && window.google.maps.OverlayView) finish();
        else finish(new Error('Maps unavailable'));
      };
      const params = new URLSearchParams({ key, loading: 'async', v: 'quarterly', language: 'es', region: 'PE', callback: callbackName });
      script.src = 'https://maps.googleapis.com/maps/api/js?' + params.toString();
      script.async = true;
      script.onerror = () => finish(new Error('Maps unavailable'));
      document.head.appendChild(script);
    }).catch((error) => {
      sdkPromise = undefined;
      throw error;
    });
    return sdkPromise;
  }

  function numberInRange(value, fallback, min, max) {
    if (typeof value !== 'string' || !value.trim()) return fallback;
    const number = Number(value);
    return Number.isFinite(number) && number >= min && number <= max ? number : fallback;
  }

  class LionSimpleMap extends HTMLElement {
    connectedCallback() {
      this.teardown();
      this.generation = (this.generation || 0) + 1;
      this.controller = new AbortController();
      this.canvas = this.querySelector('[data-map-canvas]');
      this.fallback = this.querySelector('[data-map-fallback]');
      this.controls = this.querySelector('[data-map-controls]');
      this.listeners = [];
      this.showFallback();
      const key = (this.dataset.apiKey || '').trim();
      if (!key || !this.canvas) return;
      const generation = this.generation;
      const start = () => {
        if (this.started || !this.isConnected || generation !== this.generation) return;
        this.started = true;
        if (this.observer) this.observer.disconnect();
        this.observer = null;
        this.authFailure = () => this.fail(generation);
        authFailures.add(this.authFailure);
        loadMaps(key).then((maps) => {
          if (!this.isConnected || generation !== this.generation || this.failed) return;
          this.initialize(maps, generation);
        }).catch(() => this.fail(generation));
      };
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) start();
        }, { rootMargin: '200px' });
        this.observer.observe(this);
      } else start();
    }

    initialize(maps, generation) {
      try {
        const position = {
          lat: numberInRange(this.dataset.latitude, -12.177011, -90, 90),
          lng: numberInRange(this.dataset.longitude, -77.016163, -180, 180)
        };
        const zoom = numberInRange(this.dataset.zoom, 16, 10, 20);
        const pinPosition = new maps.LatLng(position.lat, position.lng);
        this.maps = maps;
        this.map = new maps.Map(this.canvas, {
          center: position,
          zoom,
          minZoom: 10,
          maxZoom: 20,
          disableDefaultUI: true,
          cameraControl: false,
          fullscreenControl: false,
          zoomControl: false,
          mapTypeControl: false,
          streetViewControl: false,
          rotateControl: false,
          scaleControl: false,
          keyboardShortcuts: false,
          gestureHandling: 'cooperative'
        });
        const pin = this.createPin();
        class StorePin extends maps.OverlayView {
          onAdd() { this.getPanes().overlayMouseTarget.appendChild(pin); }
          draw() {
            const point = this.getProjection().fromLatLngToDivPixel(pinPosition);
            if (!point) return;
            pin.style.left = point.x + 'px';
            pin.style.top = point.y + 'px';
          }
          onRemove() { pin.remove(); }
        }
        this.overlay = new StorePin();
        this.overlay.setMap(this.map);
        this.listeners.push(this.map.addListener('zoom_changed', () => this.updateButtons()));
        let readyListener;
        readyListener = this.map.addListener('tilesloaded', () => {
          if (this.failed || !this.isConnected || generation !== this.generation) return;
          clearTimeout(this.readyTimer);
          if (readyListener) readyListener.remove();
          this.classList.add('is-ready');
          if (this.fallback) this.fallback.hidden = true;
          if (this.controls) this.controls.hidden = false;
          this.updateButtons();
        });
        this.listeners.push(readyListener);
        for (const button of this.querySelectorAll('[data-map-zoom]')) {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            if (!this.map || this.failed) return;
            const delta = Number(button.dataset.mapZoom);
            if (delta !== 1 && delta !== -1) return;
            const current = Number(this.map.getZoom());
            this.map.setZoom(Math.max(10, Math.min(20, (Number.isFinite(current) ? current : zoom) + delta)));
            this.updateButtons();
          }, { signal: this.controller.signal });
        }
        this.updateButtons();
        this.readyTimer = setTimeout(() => this.fail(generation), 15000);
      } catch (_) { this.fail(generation); }
    }

    createPin() {
      const label = (this.dataset.pinLabel || '').trim() || 'Lion Luxury';
      const title = (this.dataset.pinTitle || '').trim() || label;
      let url;
      try {
        const candidate = new URL(this.dataset.pinUrl || '', window.location.href);
        if (this.dataset.pinUrl && (candidate.protocol === 'https:' || candidate.protocol === 'http:')) url = candidate.href;
      } catch (_) {}
      const pin = document.createElement(url ? 'a' : 'span');
      pin.className = 'lion-radian-visit__map-pin';
      pin.title = title;
      if (url) {
        pin.href = url;
        pin.target = '_blank';
        pin.rel = 'noopener noreferrer';
        pin.setAttribute('aria-label', title);
      }
      const dot = document.createElement('span');
      dot.className = 'lion-radian-visit__map-pin-dot';
      dot.setAttribute('aria-hidden', 'true');
      const text = document.createElement('span');
      text.className = 'lion-radian-visit__map-pin-label';
      text.textContent = label;
      pin.appendChild(dot);
      pin.appendChild(text);
      return pin;
    }

    updateButtons() {
      if (!this.map) return;
      const zoom = Number(this.map.getZoom());
      for (const button of this.querySelectorAll('[data-map-zoom]')) {
        const delta = Number(button.dataset.mapZoom);
        button.disabled = this.failed || !Number.isFinite(zoom) || (delta === 1 ? zoom >= 20 : zoom <= 10);
      }
    }

    showFallback() {
      this.classList.remove('is-ready');
      if (this.fallback) this.fallback.hidden = false;
      if (this.controls) this.controls.hidden = true;
    }

    fail(generation) {
      if (generation !== this.generation) return;
      this.failed = true;
      clearTimeout(this.readyTimer);
      this.showFallback();
      this.clearMap();
    }

    clearMap() {
      for (const listener of this.listeners || []) {
        if (listener && typeof listener.remove === 'function') listener.remove();
      }
      this.listeners = [];
      if (this.overlay) this.overlay.setMap(null);
      this.overlay = null;
      if (this.map && this.maps && this.maps.event && typeof this.maps.event.clearInstanceListeners === 'function') this.maps.event.clearInstanceListeners(this.map);
      this.map = null;
      this.maps = null;
      if (this.canvas) this.canvas.replaceChildren();
    }

    teardown() {
      this.generation = (this.generation || 0) + 1;
      clearTimeout(this.readyTimer);
      if (this.controller) this.controller.abort();
      this.controller = null;
      if (this.observer) this.observer.disconnect();
      this.observer = null;
      if (this.authFailure) authFailures.delete(this.authFailure);
      this.authFailure = null;
      this.clearMap();
      this.started = false;
      this.failed = false;
      this.showFallback();
    }

    disconnectedCallback() { this.teardown(); }
  }

  customElements.define('lion-simple-map', LionSimpleMap);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lion-radian-voices"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click',function(event){
    const arrow=event.target.closest('[data-radian-voice-step]');
    if(!arrow)return;
    const section=arrow.closest('.lion-radian-voices');
    const track=section&&section.querySelector('[data-radian-voices-track]');
    const card=track&&track.querySelector('.lion-radian-voices__card');
    if(!track||!card)return;
    const gap=parseFloat(getComputedStyle(track).gap)||0;
    const step=Number(arrow.dataset.radianVoiceStep);
    track.scrollBy({left:step*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lion-story-intro"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lion-story-intro')) {
  customElements.define('lion-story-intro', class extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      this._slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (!this._slides.length) return;
      this._abort = new AbortController();
      this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._index = Math.max(0, this._slides.findIndex(slide => !slide.hidden));
      this._enabled = this.dataset.autoplay === 'true' && !window.Shopify?.designMode;
      this._playing = this._enabled && !this._motion.matches;
      this._hovered = false;
      this._focused = this.contains(document.activeElement);
      this._visible = true;
      this._interval = Math.max(3, Number(this.dataset.interval) || 7) * 1000;
      this._play = this.querySelector('[data-play]');
      this._counter = this.querySelector('[data-count]');
      this._viewport = this.querySelector('[data-viewport]');
      const signal = this._abort.signal;
      const on = (target, type, handler, options = {}) => target?.addEventListener(type, handler, { ...options, signal });
      on(this, 'click', event => {
        const control = event.target.closest('[data-go], [data-step], [data-play]');
        if (!control || !this.contains(control)) return;
        if (control.hasAttribute('data-play')) {
          this._playing = this._enabled && !this._motion.matches && !this._playing;
          this._sync();
          return;
        }
        const next = control.hasAttribute('data-go') ? Number(control.dataset.go) : this._index + Number(control.dataset.step);
        this._show(next, true, control);
      });
      on(this, 'keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        if (event.target.closest('a, input, textarea, select, [contenteditable]:not([contenteditable="false"]), [role="textbox"], [role="slider"], [role="combobox"]')) return;
        let next;
        if (event.key === 'ArrowLeft') next = this._index - 1;
        else if (event.key === 'ArrowRight') next = this._index + 1;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this._slides.length - 1;
        else return;
        if (this._slides.length < 2) return;
        event.preventDefault();
        this._show(next, true, event.target);
      });
      on(this, 'pointerenter', event => {
        if (event.pointerType === 'touch') return;
        this._hovered = true;
        this._sync();
      });
      on(this, 'pointerleave', () => {
        this._hovered = false;
        this._sync();
      });
      on(this, 'focusin', () => {
        this._focused = true;
        this._sync();
      });
      on(this, 'focusout', event => {
        if (event.relatedTarget && this.contains(event.relatedTarget)) return;
        this._focused = false;
        this._sync();
      });
      on(document, 'visibilitychange', () => this._sync());
      on(this._motion, 'change', () => {
        if (this._motion.matches) {
          this._playing = false;
          this._animation?.cancel();
        }
        this._sync();
      });
      on(document, 'shopify:block:select', event => {
        const index = this._slides.findIndex(slide => slide.dataset.blockId === String(event.detail?.blockId));
        if (index !== -1) this._show(index, true);
      });
      on(this._viewport, 'touchstart', event => {
        if (event.touches.length !== 1 || event.target.closest('input, textarea, select, [contenteditable]:not([contenteditable="false"])')) {
          this._touch = null;
          return;
        }
        this._touch = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }, { passive: true });
      on(this._viewport, 'touchend', event => {
        const start = this._touch;
        this._touch = null;
        if (!start || !event.changedTouches.length || this._slides.length < 2) return;
        const dx = event.changedTouches[0].clientX - start.x;
        const dy = event.changedTouches[0].clientY - start.y;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this._show(this._index + (dx < 0 ? 1 : -1), true);
      }, { passive: true });
      on(this._viewport, 'touchcancel', () => { this._touch = null; }, { passive: true });
      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(entries => {
          this._visible = entries[0].isIntersecting;
          this._sync();
        }, { threshold: 0.1 });
        this._observer.observe(this);
      }
      this.querySelectorAll('[data-controls]').forEach(control => { control.hidden = this._slides.length < 2; });
      if (this._play) this._play.hidden = !this._enabled || this._slides.length < 2;
      this._render();
      this._sync();
      this.dataset.ready = 'true';
      this._queueNextImage();
    }

    disconnectedCallback() {
      this._cancelImagePreload();
      this._abort?.abort();
      this._abort = null;
      this._observer?.disconnect();
      this._observer = null;
      this._animation?.cancel();
      this._animation = null;
      this._touch = null;
      clearTimeout(this._timer);
      delete this.dataset.ready;
    }

    _show(index, manual = false, source = null) {
      if (!Number.isFinite(index)) return;
      if (manual) {
        this._playing = false;
        if (this._counter) this._counter.setAttribute('aria-live', 'polite');
      }
      const next = ((Math.trunc(index) % this._slides.length) + this._slides.length) % this._slides.length;
      const outgoing = this._slides[this._index];
      const moveFocus = outgoing.contains(document.activeElement);
      if (!manual && moveFocus) {
        this._sync();
        return;
      }
      if (next === this._index) {
        this._sync();
        return;
      }
      this._animation?.cancel();
      this._index = next;
      const incoming = this._slides[next];
      const image = incoming.querySelector('img');
      if (image) {
        image.fetchPriority = 'high';
        image.loading = 'eager';
      }
      incoming.hidden = false;
      incoming.inert = false;
      incoming.setAttribute('aria-hidden', 'false');
      if (moveFocus) {
        const target = source && !outgoing.contains(source) && typeof source.focus === 'function'
          ? source
          : incoming.querySelector('a[href], button:not([disabled]), [tabindex="0"]');
        if (target) target.focus({ preventScroll: true });
        else {
          incoming.tabIndex = -1;
          incoming.focus({ preventScroll: true });
        }
      }
      this._render();
      if (!this._motion.matches && typeof incoming.animate === 'function') {
        this._animation = incoming.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 180, easing: 'ease-out' });
      }
      this._sync();
      this._queueNextImage();
    }

    _cancelImagePreload() {
      if (this._preloadIdle != null) window.cancelIdleCallback?.(this._preloadIdle);
      if (this._preloadFrame != null) cancelAnimationFrame(this._preloadFrame);
      clearTimeout(this._preloadTimeout);
      this._preloadImage?.removeEventListener('load', this._preloadLoad);
      this._preloadIdle = null;
      this._preloadFrame = null;
      this._preloadTimeout = null;
      this._preloadImage = null;
      this._preloadLoad = null;
    }

    _queueNextImage() {
      this._cancelImagePreload();
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (!this._abort || this._slides.length < 2 || connection?.saveData || ['slow-2g', '2g'].includes(connection?.effectiveType)) return;
      const index = this._index;
      const current = this._slides[index].querySelector('img');
      const next = this._slides[(index + 1) % this._slides.length].querySelector('img');
      if (!current || !next || next.complete && next.naturalWidth > 0) return;
      const valid = () => this._abort && this.isConnected && this._index === index;
      const preload = () => {
        this._preloadIdle = null;
        this._preloadTimeout = null;
        if (!valid() || connection?.saveData || ['slow-2g', '2g'].includes(connection?.effectiveType)) return;
        next.fetchPriority = 'low';
        next.loading = 'eager';
      };
      const queue = () => {
        if (!valid()) return;
        this._preloadFrame = requestAnimationFrame(() => {
          this._preloadFrame = requestAnimationFrame(() => {
            this._preloadFrame = null;
            if (!valid()) return;
            if ('requestIdleCallback' in window) this._preloadIdle = window.requestIdleCallback(preload, { timeout: 1500 });
            else this._preloadTimeout = setTimeout(preload, 200);
          });
        });
      };
      if (current.complete && current.naturalWidth > 0) queue();
      else {
        this._preloadImage = current;
        this._preloadLoad = queue;
        current.addEventListener('load', queue, { once: true, signal: this._abort.signal });
      }
    }

    _render() {
      this._slides.forEach((slide, index) => {
        const active = index === this._index;
        slide.hidden = !active;
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.querySelectorAll('[data-go]').forEach(button => {
        const index = Number(button.dataset.go);
        button.setAttribute('aria-pressed', String(index === this._index));
        if (this._slides[index]?.id) button.setAttribute('aria-controls', this._slides[index].id);
      });
      if (this._counter) this._counter.textContent = `${this._index + 1} / ${this._slides.length}`;
    }

    _sync() {
      clearTimeout(this._timer);
      if (!this._abort) return;
      const running = this._playing && !this._motion.matches && !this._hovered && !this._focused && this._visible && !document.hidden && this._slides.length > 1;
      if (this._counter) this._counter.setAttribute('aria-live', running ? 'off' : 'polite');
      if (this._play) {
        const label = this._playing
          ? (this._play.dataset.labelPause || this.dataset.labelPause || 'Pausar diapositivas')
          : (this._play.dataset.labelPlay || this.dataset.labelPlay || 'Reproducir diapositivas');
        this._play.setAttribute('aria-label', label);
        this._play.setAttribute('aria-pressed', String(this._playing));
        this._play.dataset.playing = String(this._playing);
        const text = this._play.querySelector('[data-play-label]');
        if (text) text.textContent = label;
      }
      if (running) this._timer = setTimeout(() => this._show(this._index + 1), this._interval);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (() => {
    const styleProperties = ['width', 'height', 'min-width', 'max-width', 'margin-left', 'margin-right', 'float', 'font-family', 'font-size', 'line-height'];

    const slugify = (value) => value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    const cleanLegacyContent = (section, content) => {
      content.querySelectorAll('style').forEach((element) => element.remove());
      content.querySelectorAll('#ll-guide-signup, .ll-guide-signup').forEach((element) => element.remove());

      content.querySelectorAll('[style]').forEach((element) => {
        styleProperties.forEach((property) => element.style.removeProperty(property));
        if (!element.getAttribute('style')?.trim()) element.removeAttribute('style');
      });

      content.querySelectorAll('img').forEach((image) => {
        image.loading = 'lazy';
        image.decoding = 'async';
        image.removeAttribute('align');
      });

      content.querySelectorAll('iframe').forEach((frame) => {
        frame.loading = 'lazy';
        frame.removeAttribute('width');
        frame.removeAttribute('height');
      });

      content.querySelectorAll('a[target="_blank"]').forEach((link) => {
        const rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
        rel.add('noopener');
        rel.add('noreferrer');
        link.setAttribute('rel', Array.from(rel).join(' '));
      });

      content.querySelectorAll('a').forEach((link) => {
        if (link.dataset.llTrack) return;
        const href = link.getAttribute('href') || '';
        let url;
        try {
          url = new URL(href, window.location.origin);
        } catch {
          link.dataset.llTrack = 'article_content_link';
          return;
        }
        const hostname = url.hostname.toLowerCase();
        if (hostname === 'wa.me' || hostname.endsWith('.wa.me') || hostname === 'whatsapp.com' || hostname.endsWith('.whatsapp.com')) {
          link.dataset.llTrack = 'whatsapp_click';
        } else if (url.pathname.includes('/collections/')) {
          link.dataset.llTrack = 'article_collection_click';
        } else if (url.pathname.includes('/products/')) {
          link.dataset.llTrack = 'article_product_click';
        } else if (url.pathname.includes('/blogs/')) {
          link.dataset.llTrack = 'article_related_click';
        } else {
          link.dataset.llTrack = 'article_content_link';
        }
      });

      content.querySelectorAll('table').forEach((table) => {
        table.removeAttribute('width');
        if (table.parentElement?.matches('.ll-table-wrap, .article-table-wrap')) {
          table.parentElement.tabIndex = 0;
          table.parentElement.setAttribute('role', 'region');
          if (!table.parentElement.getAttribute('aria-label')) {
            table.parentElement.setAttribute('aria-label', section.dataset.tableLabel || '');
          }
          return;
        }
        const wrapper = document.createElement('div');
        wrapper.className = 'll-table-wrap';
        wrapper.tabIndex = 0;
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', section.dataset.tableLabel || '');
        table.before(wrapper);
        wrapper.append(table);
      });

    };

    const buildToc = (section, content) => {
      const shell = section.querySelector('[data-toc-shell]');
      const list = section.querySelector('[data-toc-list]');
      if (!shell || !list) return;

      content.querySelectorAll('.ll-jump, .ll-mobile-jump, .article-toc').forEach((element) => element.remove());

      const headings = Array.from(content.querySelectorAll('h2')).filter((heading) => heading.textContent.trim());
      const minimum = Number(section.dataset.minTocHeadings || 2);
      if (headings.length < minimum) return;

      list.replaceChildren();
      const usedIds = new Set(Array.from(document.querySelectorAll('[id]')).map((element) => element.id));
      headings.forEach((heading, index) => {
        if (!heading.id) {
          const base = slugify(heading.textContent) || `section-${index + 1}`;
          let candidate = `${section.dataset.articleHandle || 'article'}-${base}`;
          let suffix = 2;
          while (usedIds.has(candidate)) {
            candidate = `${section.dataset.articleHandle || 'article'}-${base}-${suffix}`;
            suffix += 1;
          }
          heading.id = candidate;
          usedIds.add(candidate);
        }

        const item = document.createElement('li');
        const link = document.createElement('a');
        item.dataset.level = heading.tagName.slice(1);
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        link.dataset.llTrack = 'article_toc_link';
        item.append(link);
        list.append(item);
      });
    };

    const initializeProgress = (section, content) => {
      const progress = section.querySelector('[data-reading-progress]');
      if (!progress) return;

      let frame = 0;
      const update = () => {
        frame = 0;
        const rect = content.getBoundingClientRect();
        const start = window.scrollY + rect.top;
        const distance = Math.max(content.offsetHeight - window.innerHeight, 1);
        const value = Math.min(Math.max((window.scrollY - start) / distance, 0), 1);
        progress.style.setProperty('--ll-progress', value.toFixed(4));
        progress.setAttribute('aria-valuenow', String(Math.round(value * 100)));
      };

      const requestUpdate = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(update);
      };

      const controller = new AbortController();
      section.llProgressController = controller;
      window.addEventListener('scroll', requestUpdate, { passive: true, signal: controller.signal });
      window.addEventListener('resize', requestUpdate, { passive: true, signal: controller.signal });
      update();
    };


    const initializeRecommendations = (section, content) => {
      if (section.querySelector('[data-ll-noir]')) return;
      if (/infectado|infeccion/.test(section.dataset.articleHandle || '')) return;
      const media = window.matchMedia('(min-width: 0px)');
      const states = [];
      const handle = section.dataset.articleHandle || '';
      const category = /arete/.test(handle) ? 'arete' : /pulsera|muneca/.test(handle) ? 'pulsera' : /cadena|collar/.test(handle) ? 'cadena' : /anillo/.test(handle) ? 'anillo' : /piercing|perforacion|cicatr/.test(handle) ? 'piercing' : 'joya';
      const name = category === 'arete' && /cruz/.test(handle) ? 'arete de cruz' : category;
      const feminine = ['pulsera', 'cadena', 'joya'].includes(category);
      const headingText = 'Encuentra ' + (feminine ? 'la ' : 'el ') + name + ' que va contigo';
      const bodyText = category === 'piercing'
        ? 'Cuéntanos qué estilo tienes en mente y te ayudamos a elegir. Si tu perforación es reciente, confirma el ajuste y el momento de cambiar la joya con tu profesional.'
        : 'Discreto o con más presencia: cuéntanos qué te gusta y te ayudamos a elegir.';
      const candidates = Array.from(section.querySelectorAll('.article-cta, .ll-resource--cta, .ll-help'));
      if (!candidates.length) {
        const loose = Array.from(content.querySelectorAll('a[href*="wa.me/"], a[href*="whatsapp.com/"]')).pop();
        const paragraph = loose?.closest('p');
        if (paragraph) {
          const wrapper = document.createElement('div');
          wrapper.className = 'll-recommendation-fallback';
          paragraph.before(wrapper);
          wrapper.append(paragraph);
          candidates.push(wrapper);
        }
      }
      candidates.forEach((block) => {
        const whatsapp = block.querySelector('a[href*="wa.me/"], a[href*="whatsapp.com/"]');
        if (!whatsapp || block.parentElement.closest('.article-cta, .ll-resource--cta')) return;
        const originalNodes = Array.from(block.childNodes);
        const originalHeading = block.querySelector('h2, h3');
        const sourceImage = block.querySelector('img') || content.querySelector('a[href*="/products/"] img') || section.querySelector('.ll-article__hero img');
        const card = document.createElement('div');
        card.className = 'll-recommendation';
        if (sourceImage) {
          const image = sourceImage.cloneNode(false);
          image.removeAttribute('id');
          image.removeAttribute('style');
          image.loading = 'lazy';
          image.decoding = 'async';
          image.sizes = '(min-width: 990px) 360px, (min-width: 750px) 600px, calc(100vw - 40px)';
          const visual = document.createElement('div');
          visual.className = 'll-recommendation__media';
          visual.append(image);
          card.append(visual);
        } else {
          card.classList.add('ll-recommendation--text');
        }
        const copy = document.createElement('div');
        copy.className = 'll-recommendation__copy';
        const eyebrow = document.createElement('p');
        eyebrow.className = 'll-recommendation__eyebrow';
        eyebrow.textContent = 'TU PRÓXIMO FAVORITO';
        const title = document.createElement(originalHeading?.tagName || 'h3');
        title.className = 'll-recommendation__title';
        title.textContent = headingText;
        if (originalHeading?.id) title.id = originalHeading.id;
        const text = document.createElement('p');
        text.className = 'll-recommendation__text';
        text.textContent = bodyText;
        const button = whatsapp.cloneNode(false);
        button.removeAttribute('id');
        button.removeAttribute('style');
        button.className = 'll-recommendation__button';
        button.textContent = 'Pedir una recomendación por WhatsApp';
        const links = document.createElement('div');
        links.className = 'll-recommendation__links';
        const seen = new Set();
        block.querySelectorAll('a[href*="/collections/"], a[href*="/products/"]').forEach((link) => {
          const href = link.getAttribute('href');
          if (seen.has(href)) return;
          seen.add(href);
          const item = link.cloneNode(false);
          item.removeAttribute('id');
          item.removeAttribute('style');
          item.className = 'll-recommendation__link';
          item.textContent = link.textContent.trim() || 'Explorar la colección';
          links.append(item);
        });
        copy.append(eyebrow, title, text, button);
        if (links.childElementCount) copy.append(links);
        card.append(copy);
        states.push({block, originalNodes, card});
      });
      const update = () => states.forEach(({block, originalNodes, card}) => {
        if (media.matches) {
          block.classList.add('ll-recommendation-host');
          block.replaceChildren(card);
        } else {
          block.classList.remove('ll-recommendation-host');
          block.replaceChildren(...originalNodes);
        }
      });
      media.addEventListener('change', update);
      section.llRecommendationsCleanup = () => media.removeEventListener('change', update);
      update();
    };

    const initializeArticle = (section) => {
      if (section.dataset.llInitialized === 'true') return;
      const content = section.querySelector('[data-article-content]');
      if (!content) return;
      section.dataset.llInitialized = 'true';
      cleanLegacyContent(section, content);
      buildToc(section, content);
      if (section.dataset.articleHandle === 'guias/medidas-piercing-calibres-diametros-largos-cierres') {
        const mobileIntroMedia = window.matchMedia('(max-width: 749px)');
        const toc = section.querySelector('[data-toc-details]');
        const updateMobileIntro = () => {
          if (toc && mobileIntroMedia.matches) toc.open = false;
        };
        updateMobileIntro();
        mobileIntroMedia.addEventListener('change', updateMobileIntro);
        section.llMobileIntroCleanup = () => mobileIntroMedia.removeEventListener('change', updateMobileIntro);
      }
      initializeProgress(section, content);
      initializeRecommendations(section, content);
    };

    const initializeWithin = (root = document) => {
      if (root.matches?.('[data-ll-article]')) initializeArticle(root);
      root.querySelectorAll?.('[data-ll-article]').forEach(initializeArticle);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeWithin());
    } else {
      initializeWithin();
    }

    document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.matches?.('[data-ll-article]') ? event.target : event.target.querySelector?.('[data-ll-article]');
      section?.llProgressController?.abort();
      section?.llRecommendationsCleanup?.();
      section?.llMobileIntroCleanup?.();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    const initializeCollection = (root) => {
      if (!root || root.dataset.collectionReady === 'true') return;
      root.dataset.collectionReady = 'true';

      const filterForm = root.querySelector('[data-facets-form]');
      const previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
      const currentParams = new URL(window.location.href).searchParams;
      root.querySelectorAll('[data-fallback-min], [data-fallback-max], [data-fallback-available]').forEach((input) => {
        if (input.type === 'checkbox') input.checked = currentParams.get(input.name) === input.value;
        else input.value = currentParams.get(input.name) || '';
      });
      if (filterForm && previewThemeId) {
        const previewInput = document.createElement('input');
        previewInput.type = 'hidden';
        previewInput.name = 'preview_theme_id';
        previewInput.value = previewThemeId;
        filterForm.append(previewInput);
      }
      const sort = root.querySelector('[data-sort-by]');
      const fallbackFilters = root.querySelector('[data-fallback-filters]');
      const currentSort = sort?.value;
      const submitFilters = () => {
        if (filterForm) filterForm.requestSubmit();
      };

      filterForm?.addEventListener('change', (event) => {
        if (event.target.matches('input[type="checkbox"]')) submitFilters();
      });
      sort?.addEventListener('change', submitFilters);

      const facetsShell = root.querySelector('[data-facets-shell]');
      const mobile = window.matchMedia('(max-width: 989px)');
      const sortToolbar = sort?.closest('.collection-toolbar');
      const sortDesktopParent = root.querySelector('.collection-catalog');
      const sortDesktopNext = root.querySelector('.collection-catalog__body');
      const sortWasInsideFacets = root.dataset.collectionHandle === 'aretes';
      const syncSortPlacement = () => {
        if (!sortToolbar || !facetsShell || sortWasInsideFacets) return;
        if (mobile.matches) {
          if (sortToolbar.parentElement !== facetsShell) facetsShell.querySelector('.collection-facets__toggle')?.after(sortToolbar);
        } else if (sortToolbar.parentElement !== sortDesktopParent) {
          sortDesktopParent?.insertBefore(sortToolbar, sortDesktopNext);
        }
      };
      syncSortPlacement();
      mobile.addEventListener?.('change', syncSortPlacement);
      const syncFacets = () => {
        if (!facetsShell) return;
        if (mobile.matches) facetsShell.removeAttribute('open');
        else facetsShell.setAttribute('open', '');
      };
      if (facetsShell?.dataset.facetsInitialized !== 'true') syncFacets();
      mobile.addEventListener?.('change', syncFacets);

      const grid = root.querySelector('[data-product-grid]');
      const progress = root.querySelector('[data-product-progress]');
      const status = root.querySelector('[data-load-more-status]');
      const sentinel = root.querySelector('[data-infinite-sentinel]');
      const loading = root.querySelector('[data-infinite-loading]');
      let nextLink = root.querySelector('[data-load-more]');
      let observer;
      let controller;
      let fetching = false;
      let loadPromise;
      let filtering = false;
      let pageActive = true;
      let filterGeneration = 0;
      let filterUpdateUrl = false;
      let interruptedFilterUpdate = null;
      let activeFilterPromise = Promise.resolve();
      const loadedPages = new Set();
      try {
        JSON.parse(root.dataset.positionPages || '[]').forEach((page) => loadedPages.add(page));
      } catch {}
      delete root.dataset.positionPages;
      const desktop = window.matchMedia('(min-width: 990px)');
      const positionKey = 'lionCollectionPosition';
      const collectionUrl = () => window.location.pathname + window.location.search;
      const readPosition = () => {
        const saved = window.history.state?.[positionKey];
        if (!desktop.matches || !grid || saved?.version !== 1 || saved.sectionId !== root.dataset.sectionId || saved.url !== collectionUrl()) return null;
        if (!Number.isFinite(saved.x) || !Number.isFinite(saved.y) || !Number.isFinite(saved.anchorTop) || !Array.isArray(saved.pages) || !Number.isInteger(saved.itemCount) || saved.itemCount < 0) return null;
        return saved;
      };
      const navigationType = window.performance?.getEntriesByType('navigation')[0]?.type;

      const mobileNavigationKey = 'lionCollectionMobileReturn';
      let mobileNavigationAnchor = null;
      let mobileNavigationRestoring = false;
      let mobileNavigationGeneration = 0;
      const readMobileNavigation = () => {
        const saved = window.history.state?.[mobileNavigationKey];
        if (!mobile.matches || !facetsShell || saved?.version !== 1 || saved.namespace !== root.dataset.positionNamespace || saved.sectionId !== root.dataset.sectionId || saved.url !== collectionUrl() || saved.open !== true) return null;
        if (!Number.isFinite(saved.x) || !Number.isFinite(saved.y) || saved.x < 0 || saved.y < 0 || !Array.isArray(saved.groups) || saved.groups.length > 50 || !saved.groups.every((open) => typeof open === 'boolean')) return null;
        return saved;
      };
      const saveMobileNavigation = (anchor = null) => {
        if (!mobile.matches || !facetsShell || mobileNavigationRestoring) return;
        const previous = window.history.state;
        const state = previous && typeof previous === 'object' ? { ...previous } : {};
        try {
          if (!facetsShell.open) {
            if (!(mobileNavigationKey in state)) return;
            delete state[mobileNavigationKey];
          } else {
            const links = [...facetsShell.querySelectorAll('a[href]')];
            const target = anchor?.isConnected && facetsShell.contains(anchor) ? anchor : links.find((link) => {
              const rect = link.getBoundingClientRect();
              return rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
            });
            state[mobileNavigationKey] = {
              version: 1,
              namespace: root.dataset.positionNamespace,
              sectionId: root.dataset.sectionId,
              url: collectionUrl(),
              open: facetsShell.open,
              groups: [...facetsShell.querySelectorAll('details')].map((group) => group.open),
              x: window.scrollX,
              y: window.scrollY,
              anchorHref: target?.href || '',
              anchorTop: target?.getBoundingClientRect().top || 0
            };
          }
          window.history.replaceState(state, '', window.location.href);
        } catch {}
      };
      const restoreMobileNavigation = async (saved) => {
        if (!mobile.matches) return;
        if (!saved || !root.isConnected) {
          if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'auto';
          return;
        }
        const generation = ++mobileNavigationGeneration;
        mobileNavigationRestoring = true;
        mobileNavigationAnchor = null;
        facetsShell.open = saved.open;
        [...facetsShell.querySelectorAll('details')].forEach((group, index) => {
          if (typeof saved.groups[index] === 'boolean') group.open = saved.groups[index];
        });
        if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
        const position = () => {
          if (generation !== mobileNavigationGeneration || !pageActive || !mobile.matches || !root.isConnected || saved.url !== collectionUrl()) return;
          const anchor = typeof saved.anchorHref === 'string' && Number.isFinite(saved.anchorTop)
            ? [...facetsShell.querySelectorAll('a[href]')].find((link) => link.href === saved.anchorHref && link.getBoundingClientRect().height > 0)
            : null;
          const top = anchor ? window.scrollY + anchor.getBoundingClientRect().top - saved.anchorTop : saved.y;
          window.scrollTo({ left: saved.x, top: Math.max(0, top), behavior: 'instant' });
        };
        try {
          position();
          await document.fonts?.ready;
          await new Promise((resolve) => window.requestAnimationFrame(resolve));
          position();
          await new Promise((resolve) => window.requestAnimationFrame(resolve));
          position();
        } finally {
          if (generation === mobileNavigationGeneration) {
            mobileNavigationRestoring = false;
            if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'auto';
          }
        }
      };
      const cancelMobileNavigation = (event) => {
        if (!mobileNavigationRestoring) return;
        if (event.type === 'keydown' && !['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) return;
        mobileNavigationGeneration += 1;
        mobileNavigationRestoring = false;
        if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'auto';
      };
      ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach((type) => window.addEventListener(type, cancelMobileNavigation, { passive: true }));
      facetsShell?.addEventListener('click', (event) => {
        if (!mobile.matches || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.defaultPrevented) return;
        const link = event.target.closest('a[href]');
        if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
        const destination = new URL(link.href, window.location.href);
        if (destination.origin !== window.location.origin || destination.href === window.location.href) return;
        mobileNavigationAnchor = link;
        saveMobileNavigation(link);
      }, { capture: true });
      const initialPosition = navigationType === 'back_forward' ? readPosition() : null;
      if (desktop.matches && !initialPosition && 'scrollRestoration' in window.history) window.history.scrollRestoration = 'auto';
      let restoringPosition = Boolean(initialPosition);
      let restorationCancelled = false;
      let restorationGeneration = 0;
      let requestGeneration = 0;
      let nearEndFrame = null;
      const canLoadNearEnd = () => root.dataset.infiniteScroll === 'true'
        && pageActive && !restoringPosition && !filtering && !fetching
        && grid && nextLink?.isConnected && sentinel?.isConnected
        && !root.classList.contains('is-infinite-error');
      const scheduleNearEndCheck = () => {
        if (nearEndFrame !== null || !canLoadNearEnd()) return;
        nearEndFrame = window.requestAnimationFrame(() => {
          nearEndFrame = null;
          if (canLoadNearEnd() && sentinel.getBoundingClientRect().top <= window.innerHeight + 900) loadNext();
        });
      };
      const cancelNearEndCheck = () => {
        if (nearEndFrame === null) return;
        window.cancelAnimationFrame(nearEndFrame);
        nearEndFrame = null;
      };
      const resumeObserver = () => {
        if (!canLoadNearEnd()) return;
        observer?.observe(sentinel);
        scheduleNearEndCheck();
      };
      let positionSnapshotRevision = 0;
      let preparedPositionSnapshot = null;
      let positionSnapshotTask = null;
      const positionSnapshotIsCurrent = (snapshot) => snapshot
        && snapshot.revision === positionSnapshotRevision
        && snapshot.url === collectionUrl()
        && Date.now() - snapshot.time < 540000;
      const preparePositionSnapshot = () => {
        if (!desktop.matches || !grid || !pageActive || restoringPosition || filtering || positionSnapshotIsCurrent(preparedPositionSnapshot)) return;
        const namespace = root.dataset.positionNamespace;
        if (!namespace) return;
        try {
          const storage = window.sessionStorage;
          const previous = window.history.state?.[positionKey];
          const cacheKey = previous?.url === collectionUrl() && previous.cacheKey?.startsWith(namespace + ':')
            ? previous.cacheKey
            : namespace + ':' + Date.now().toString(36) + Math.random().toString(36).slice(2);
          const items = grid.querySelectorAll('[data-product-grid-item]');
          const copy = grid.cloneNode(true);
          window.LionDesktopImages?.resetSnapshot(copy);
          copy.querySelectorAll('[data-quick-add-ready]').forEach((form) => form.removeAttribute('data-quick-add-ready'));
          copy.querySelectorAll('[data-submitting]').forEach((element) => element.removeAttribute('data-submitting'));
          copy.querySelectorAll('[aria-busy]').forEach((element) => element.removeAttribute('aria-busy'));
          copy.querySelectorAll('[data-secondary-ready]').forEach((element) => element.removeAttribute('data-secondary-ready'));
          copy.querySelectorAll('.is-loading, .is-success').forEach((button) => {
            button.classList.remove('is-loading', 'is-success');
            button.removeAttribute('aria-busy');
            if (button.dataset.variantAvailable !== 'false') button.removeAttribute('disabled');
          });
          const snapshot = {
            namespace,
            sectionId: root.dataset.sectionId,
            url: collectionUrl(),
            time: Date.now(),
            itemCount: items.length,
            pages: [...loadedPages],
            nextHref: nextLink?.getAttribute('href') || null,
            html: copy.innerHTML
          };
          const keys = [];
          for (let index = 0; index < storage.length; index += 1) {
            const key = storage.key(index);
            if (key?.startsWith(namespace + ':')) keys.push(key);
          }
          if (!keys.includes(cacheKey) && keys.length >= 3) storage.removeItem(keys[0]);
          storage.setItem(cacheKey, JSON.stringify(snapshot));
          preparedPositionSnapshot = {
            cacheKey,
            revision: positionSnapshotRevision,
            url: snapshot.url,
            time: snapshot.time,
            itemCount: snapshot.itemCount,
            pages: JSON.stringify(snapshot.pages),
            nextHref: snapshot.nextHref
          };
        } catch {
          preparedPositionSnapshot = null;
        }
      };
      const schedulePositionSnapshot = () => {
        if (!desktop.matches || !grid || !pageActive || positionSnapshotTask || positionSnapshotIsCurrent(preparedPositionSnapshot)) return;
        const prepare = () => {
          positionSnapshotTask = null;
          preparePositionSnapshot();
        };
        positionSnapshotTask = typeof window.requestIdleCallback === 'function'
          ? { id: window.requestIdleCallback(prepare, { timeout: 1500 }), idle: true }
          : { id: window.setTimeout(prepare, 150), idle: false };
      };
      const invalidatePositionSnapshot = () => {
        positionSnapshotRevision += 1;
        preparedPositionSnapshot = null;
        schedulePositionSnapshot();
      };
      const cancelPositionSnapshotPreparation = () => {
        if (!positionSnapshotTask) return;
        if (positionSnapshotTask.idle) window.cancelIdleCallback?.(positionSnapshotTask.id);
        else window.clearTimeout(positionSnapshotTask.id);
        positionSnapshotTask = null;
      };
      const savePosition = () => {
        if (!desktop.matches || !grid || (restoringPosition && !restorationCancelled)) return;
        const items = [...grid.querySelectorAll('[data-product-grid-item]')];
        const anchor = items.find((item) => {
          if (item.hidden) return false;
          const rect = item.getBoundingClientRect();
          return rect.bottom > 0 && rect.top < window.innerHeight;
        });
        const state = window.history.state;
        try {
          const snapshot = preparedPositionSnapshot;
          const cacheKey = positionSnapshotIsCurrent(snapshot)
            && snapshot.itemCount === items.length
            && snapshot.pages === JSON.stringify([...loadedPages])
            && snapshot.nextHref === (nextLink?.getAttribute('href') || null)
            ? snapshot.cacheKey
            : null;
          window.history.replaceState({
            ...(state && typeof state === 'object' ? state : {}),
            [positionKey]: {
              version: 1,
              cacheKey,
              sectionId: root.dataset.sectionId,
              url: collectionUrl(),
              x: window.scrollX,
              y: window.scrollY,
              pages: [...loadedPages],
              itemCount: items.length,
              anchorProductId: anchor?.dataset.productId || '',
              anchorTop: anchor?.getBoundingClientRect().top || 0
            }
          }, '', window.location.href);
          if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'auto';
        } catch {}
      };
      const cancelRestoration = (event) => {
        if (!restoringPosition) return;
        if (event.type === 'keydown' && !['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) return;
        restorationCancelled = true;
        window.lionCollectionReturn?.release();
      };
      ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach((type) => window.addEventListener(type, cancelRestoration, { passive: true }));

      const updateProgress = () => {
        if (!grid || !progress) return;
        const shown = grid.querySelectorAll('[data-product-grid-item]').length;
        progress.textContent = progress.dataset.progressTemplate
          .replace('[shown]', String(shown))
          .replace('[total]', progress.dataset.total);
      };

      const loadNextPage = async () => {
        if (!pageActive || !nextLink || !nextLink.isConnected || !grid || fetching || root.classList.contains('is-infinite-error')) return;
        fetching = true;
        cancelNearEndCheck();
        if (sentinel) observer?.unobserve(sentinel);
        nextLink.setAttribute('aria-busy', 'true');
        if (loading) loading.hidden = false;
        controller = new AbortController();
        const activeController = controller;
        const activeGeneration = ++requestGeneration;
        let requestTimer;
        let requestTimedOut = false;
        let rejectAbortedRequest;

        try {
          const pageUrl = new URL(nextLink.getAttribute('href'), window.location.href);
          const previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
          if (previewThemeId && !pageUrl.searchParams.has('preview_theme_id')) pageUrl.searchParams.set('preview_theme_id', previewThemeId);
          if (pageUrl.origin !== window.location.origin || loadedPages.has(pageUrl.href)) throw new Error('Invalid collection page');
          const sectionUrl = new URL(pageUrl);
          sectionUrl.searchParams.set('section_id', root.dataset.sectionId);
          const requestDeadline = new Promise((resolve, reject) => {
            rejectAbortedRequest = () => {
              const error = new Error(requestTimedOut ? 'Collection load timed out' : 'Collection load aborted');
              error.name = requestTimedOut ? 'TimeoutError' : 'AbortError';
              reject(error);
            };
            activeController.signal.addEventListener('abort', rejectAbortedRequest, { once: true });
            requestTimer = window.setTimeout(() => {
              requestTimedOut = true;
              activeController.abort();
            }, 20000);
          });
          const responseText = await Promise.race([
            fetch(sectionUrl.href, {
              credentials: 'same-origin',
              headers: { Accept: 'text/html' },
              signal: activeController.signal
            }).then((response) => {
              if (!response.ok) throw new Error(String(response.status));
              return response.text();
            }),
            requestDeadline
          ]);
          if (activeController.signal.aborted || activeGeneration !== requestGeneration || !pageActive) return;
          const documentFragment = new DOMParser().parseFromString(responseText, 'text/html');
          const incomingRoot = [...documentFragment.querySelectorAll('[data-collection-section]')]
            .find((section) => section.dataset.sectionId === root.dataset.sectionId);
          const incomingGrid = incomingRoot?.querySelector('[data-product-grid]');
          const incomingItems = incomingGrid?.querySelectorAll('[data-product-grid-item]');
          if (!incomingItems?.length) throw new Error('Missing collection products');

          const incomingLink = incomingRoot.querySelector('[data-load-more]');
          const nextHref = incomingLink?.getAttribute('href');
          const followingUrl = nextHref ? new URL(nextHref, pageUrl) : null;
          followingUrl?.searchParams.delete('section_id');
          if (followingUrl && previewThemeId && !followingUrl.searchParams.has('preview_theme_id')) {
            followingUrl.searchParams.set('preview_theme_id', previewThemeId);
          }
          if (followingUrl && (followingUrl.origin !== window.location.origin || followingUrl.href === pageUrl.href || loadedPages.has(followingUrl.href))) {
            throw new Error('Invalid next collection page');
          }

          incomingItems.forEach((item) => grid.append(item));
          loadedPages.add(pageUrl.href);
          updateProgress();
          if (status) status.textContent = status.dataset.loadedLabel.replace('[count]', String(incomingItems.length));

          if (followingUrl) {
            nextLink.href = followingUrl.href;
          } else {
            observer?.disconnect();
            nextLink.remove();
            nextLink = null;
            sentinel?.remove();
            root.classList.add('is-infinite-complete');
          }
          invalidatePositionSnapshot();
        } catch (error) {
          if (pageActive && activeGeneration === requestGeneration && (requestTimedOut || error.name !== 'AbortError')) {
            observer?.disconnect();
            root.classList.add('is-infinite-error');
            if (status) status.textContent = status.dataset.errorLabel;
          }
        } finally {
          window.clearTimeout(requestTimer);
          if (rejectAbortedRequest) activeController.signal.removeEventListener('abort', rejectAbortedRequest);
          if (activeGeneration === requestGeneration) {
            fetching = false;
            controller = null;
            if (nextLink) nextLink.removeAttribute('aria-busy');
            if (loading) loading.hidden = true;
            if (sentinel) observer?.unobserve(sentinel);
            resumeObserver();
          }
        }
      };

      const loadNext = () => {
        if (fetching) return loadPromise;
        loadPromise = loadNextPage();
        return loadPromise;
      };

      const applyFallbackFilters = async (updateUrl = false) => {
        if (!fallbackFilters || !grid || filtering) return;
        filtering = true;
        filterUpdateUrl = updateUrl;
        const activeFilterGeneration = ++filterGeneration;
        const feedback = root.querySelector('[data-fallback-status]');
        const empty = root.querySelector('[data-fallback-empty]');
        const minInput = root.querySelector('[data-fallback-min]');
        const maxInput = root.querySelector('[data-fallback-max]');
        const availableInput = root.querySelector('[data-fallback-available]');
        const minimum = minInput?.value ? Number(minInput.value) * 100 : 0;
        const maximum = maxInput?.value ? Number(maxInput.value) * 100 : Infinity;
        const onlyAvailable = availableInput?.checked;
        const hasFilters = minimum > 0 || Number.isFinite(maximum) || onlyAvailable;
        if (feedback) {
          feedback.hidden = false;
          feedback.textContent = feedback.dataset.busyLabel;
        }
        filterForm?.setAttribute('aria-busy', 'true');
        observer?.disconnect();
        try {
          if (hasFilters) {
            while (pageActive && activeFilterGeneration === filterGeneration && nextLink?.isConnected && !root.classList.contains('is-infinite-error')) {
              const previousSize = loadedPages.size;
              await loadNext();
              if (!pageActive || activeFilterGeneration !== filterGeneration) return;
              if (loadedPages.size === previousSize) throw new Error('Collection load interrupted');
            }
            if (root.classList.contains('is-infinite-error')) throw new Error('Collection load failed');
          }
          if (!pageActive || activeFilterGeneration !== filterGeneration) return;
          let matched = 0;
          grid.querySelectorAll('[data-product-grid-item]').forEach((item) => {
            const prices = JSON.parse(onlyAvailable ? item.dataset.availablePrices : item.dataset.productPrices);
            const matches = prices.some((price) => price >= minimum && price <= maximum);
            item.hidden = !matches;
            if (matches) matched += 1;
          });
          if (empty) empty.hidden = matched !== 0;
          if (feedback) {
            feedback.hidden = !hasFilters;
            feedback.textContent = feedback.dataset.resultLabel.replace('[count]', String(matched));
          }
          if (updateUrl) {
            const nextUrl = new URL(window.location.href);
            ['filter.v.price.gte', 'filter.v.price.lte', 'filter.v.availability'].forEach((key) => nextUrl.searchParams.delete(key));
            if (minInput?.value) nextUrl.searchParams.set(minInput.name, minInput.value);
            if (maxInput?.value) nextUrl.searchParams.set(maxInput.name, maxInput.value);
            if (onlyAvailable) nextUrl.searchParams.set(availableInput.name, availableInput.value);
            window.history.replaceState(window.history.state, '', nextUrl);
          }
          invalidatePositionSnapshot();
        } catch (error) {
          if (activeFilterGeneration === filterGeneration && feedback) feedback.textContent = feedback.dataset.errorLabel;
        } finally {
          if (activeFilterGeneration === filterGeneration) {
            filtering = false;
            filterForm?.removeAttribute('aria-busy');
            resumeObserver();
            schedulePositionSnapshot();
          }
        }
      };

      filterForm?.addEventListener('submit', (event) => {
        if (!fallbackFilters || sort?.value !== currentSort) return;
        event.preventDefault();
        activeFilterPromise = applyFallbackFilters(true);
      });

      root.addEventListener('click', (event) => {
        const link = event.target.closest('[data-load-more]');
        if (!link || !root.contains(link) || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        root.classList.remove('is-infinite-error');
        if (status) status.textContent = '';
        loadNext();
      });
      root.addEventListener('click', (event) => {
        const colorButton = event.target.closest('[data-card-color]');
        if (colorButton && grid?.contains(colorButton)) invalidatePositionSnapshot();
        if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.defaultPrevented) return;
        const link = event.target.closest('a[href]');
        if (!link || !grid?.contains(link) || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
        const destination = new URL(link.href, window.location.href);
        if (destination.origin === window.location.origin && destination.pathname.includes('/products/')) savePosition();
      }, { capture: true });

      if (root.dataset.infiniteScroll === 'true' && nextLink && sentinel) {
        root.classList.add('is-infinite-ready');
        if ('IntersectionObserver' in window) {
          observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) scheduleNearEndCheck();
          }, { rootMargin: '900px 0px' });
        }
        window.addEventListener('scroll', scheduleNearEndCheck, { passive: true });
        window.addEventListener('resize', scheduleNearEndCheck, { passive: true });
        resumeObserver();
      }

      activeFilterPromise = fallbackFilters && (currentParams.get('filter.v.price.gte') || currentParams.get('filter.v.price.lte') || currentParams.get('filter.v.availability'))
        ? applyFallbackFilters()
        : Promise.resolve();
      const nextFrame = () => new Promise((resolve) => window.requestAnimationFrame(resolve));
      const positionAt = (saved) => {
        window.LionDesktopImages?.prepareReturn(root, saved);
        const items = [...grid.querySelectorAll('[data-product-grid-item]')];
        const anchor = items.find((item) => !item.hidden && item.dataset.productId === saved.anchorProductId);
        const top = anchor ? window.scrollY + anchor.getBoundingClientRect().top - saved.anchorTop : saved.y;
        if (Math.abs(window.scrollY - top) > 1 || Math.abs(window.scrollX - saved.x) > 1) window.scrollTo({ left: saved.x, top: Math.max(0, top), behavior: 'instant' });
      };
      if (window.lionCollectionReturn) window.lionCollectionReturn.onCancel = () => {
        restorationCancelled = true;
        restorationGeneration += 1;
        restoringPosition = false;
        delete root.dataset.positionRestoring;
        updateProgress();
        resumeObserver();
        schedulePositionSnapshot();
      };
      const restorePosition = async (saved) => {
        if (!saved || !root.isConnected) {
          if (desktop.matches && 'scrollRestoration' in window.history) window.history.scrollRestoration = 'auto';
          window.lionCollectionReturn?.release();
          resumeObserver();
          schedulePositionSnapshot();
          return;
        }
        const generation = ++restorationGeneration;
        restoringPosition = true;
        restorationCancelled = false;
        root.dataset.positionRestoring = 'true';
        observer?.disconnect();
        try {
          if (grid.querySelectorAll('[data-product-grid-item]').length >= saved.itemCount && loadedPages.size >= saved.pages.length && !window.lionCollectionReturn?.cancelled) positionAt(saved);
          await activeFilterPromise;
          while (pageActive && !restorationCancelled && !window.lionCollectionReturn?.cancelled && generation === restorationGeneration && nextLink?.isConnected && loadedPages.size < saved.pages.length && !root.classList.contains('is-infinite-error')) {
            const previousSize = loadedPages.size;
            await loadNext();
            if (loadedPages.size === previousSize) break;
          }
          if (pageActive && !restorationCancelled && !window.lionCollectionReturn?.cancelled && generation === restorationGeneration) positionAt(saved);
          await document.fonts?.ready;
          await nextFrame();
          await nextFrame();
          if (restorationCancelled || window.lionCollectionReturn?.cancelled || generation !== restorationGeneration || !desktop.matches || !root.isConnected || saved.url !== collectionUrl()) return;
          positionAt(saved);
          await nextFrame();
          if (!restorationCancelled && !window.lionCollectionReturn?.cancelled && generation === restorationGeneration) positionAt(saved);
        } finally {
          if (generation === restorationGeneration) {
            restoringPosition = false;
            delete root.dataset.positionRestoring;
            window.lionCollectionReturn?.release();
            updateProgress();
            resumeObserver();
            schedulePositionSnapshot();
          }
        }
      };

      filterForm?.addEventListener('submit', (event) => { if (!event.defaultPrevented) controller?.abort(); });
      window.addEventListener('pagehide', () => {
        savePosition();
        cancelNearEndCheck();
        cancelPositionSnapshotPreparation();
        saveMobileNavigation(mobileNavigationAnchor);
        mobileNavigationGeneration += 1;
        mobileNavigationRestoring = false;
        if (mobile.matches && 'scrollRestoration' in window.history) window.history.scrollRestoration = 'auto';
        window.lionCollectionReturn?.release();
        pageActive = false;
        interruptedFilterUpdate = filtering ? filterUpdateUrl : null;
        filtering = false;
        filterGeneration += 1;
        restorationGeneration += 1;
        requestGeneration += 1;
        controller?.abort();
        fetching = false;
        controller = null;
        loadPromise = undefined;
        observer?.disconnect();
      });
      window.addEventListener('pageshow', (event) => {
        if (!event.persisted || !root.isConnected) return;
        pageActive = true;
        fetching = false;
        controller = null;
        loadPromise = undefined;
        restoringPosition = false;
        if (loading) loading.hidden = true;
        nextLink?.removeAttribute('aria-busy');
        updateProgress();
        if (interruptedFilterUpdate !== null) {
          activeFilterPromise = applyFallbackFilters(interruptedFilterUpdate);
          interruptedFilterUpdate = null;
        }
        const saved = readPosition();
        if (saved && grid.querySelectorAll('[data-product-grid-item]').length >= saved.itemCount && loadedPages.size >= saved.pages.length) {
          if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
          positionAt(saved);
          window.lionCollectionReturn?.release();
          resumeObserver();
          schedulePositionSnapshot();
        } else {
          if (saved) window.lionCollectionReturn?.restart();
          restorePosition(saved);
        }
        scheduleNearEndCheck();
      });
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) restoreMobileNavigation(readMobileNavigation());
      });
      if (navigationType === 'back_forward') restoreMobileNavigation(readMobileNavigation());
      if (initialPosition) restorePosition(initialPosition);
      else schedulePositionSnapshot();
      grid?.addEventListener('pointerover', schedulePositionSnapshot, { passive: true });
      grid?.addEventListener('focusin', schedulePositionSnapshot);
      desktop.addEventListener?.('change', schedulePositionSnapshot);
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-collection-section]').forEach(initializeCollection);
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
    else initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  (() => {
    const init = () => {
      const section = document.querySelector('.llv-clean-guide');
      if (!section) return;
      const desktop = window.matchMedia('(min-width: 701px)');
      let previousTop;
      const update = () => {
        if (!desktop.matches) return;
        const top = Math.max(0, section.getBoundingClientRect().top + window.scrollY);
        if (top === previousTop) return;
        previousTop = top;
        section.style.setProperty('--llv-header-stack-height', `${top}px`);
      };
      update();
      desktop.addEventListener('change', update);
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(update);
        document.querySelectorAll('.shopify-section-group-header-group').forEach((header) => observer.observe(header));
      } else {
        window.addEventListener('resize', update, { passive: true });
      }
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const money = (value) => {
      if (window.LionTheme?.formatMoney) return window.LionTheme.formatMoney(value);
      return new Intl.NumberFormat(document.documentElement.lang || 'es-PE', { style: 'currency', currency: 'PEN' }).format(Number(value || 0) / 100);
    };

    const replaceTemplate = (template, replacements) => Object.entries(replacements).reduce(
      (result, [key, value]) => result.split(`[${key}]`).join(String(value ?? '')),
      String(template || '')
    );

    const addButtonStateTimers = new WeakMap();

    const setAddButtonState = (button, state, root) => {
      if (!(button instanceof HTMLButtonElement)) return;
      const label = button.querySelector('[data-add-to-cart-text]');
      const support = button.querySelector('[data-add-to-cart-support]');
      if (support && button.dataset.normalSupport === undefined) button.dataset.normalSupport = support.textContent.trim();
      const isAvailable = root?.currentVariant
        ? Boolean(root.currentVariant.available)
        : button.dataset.variantAvailable !== 'false' && !button.disabled;
      const labels = {
        loading: button.dataset.loadingLabel,
        success: button.dataset.successLabel,
        error: button.dataset.errorLabel,
        idle: isAvailable ? (button.dataset.availableLabel || root?.dataset.addLabel) : (button.dataset.soldLabel || root?.dataset.soldLabel)
      };
      const supportLabels = {
        loading: button.dataset.loadingSupport,
        success: button.dataset.successSupport,
        error: button.dataset.errorSupport,
        idle: button.dataset.normalSupport
      };
      const nextLabel = labels[state] || labels.idle || '';
      const nextSupport = supportLabels[state] || '';
      button.classList.toggle('is-loading', state === 'loading');
      button.classList.toggle('is-success', state === 'success');
      button.classList.toggle('is-error', state === 'error');
      if (label && nextLabel) label.textContent = nextLabel;
      if (support) {
        support.textContent = nextSupport;
        support.hidden = !nextSupport;
      }
    };

    const resetAddButtonLater = (button, root, delay) => {
      const activeTimer = addButtonStateTimers.get(button);
      if (activeTimer) window.clearTimeout(activeTimer);
      const timer = window.setTimeout(() => {
        if (!button.isConnected) return;
        setAddButtonState(button, 'idle', root);
        addButtonStateTimers.delete(button);
      }, delay);
      addButtonStateTimers.set(button, timer);
    };

    const setWhatsappDisabled = (link, disabled) => {
      if (!link) return;
      link.setAttribute('aria-disabled', String(disabled));
      if (disabled) {
        link.removeAttribute('href');
        link.setAttribute('tabindex', '-1');
      } else {
        link.removeAttribute('tabindex');
      }
    };

    const updateWhatsapp = (root, variant, formattedPrice) => {
      if (!root || !variant) return;
      const quantityInput = root.querySelector('[data-product-quantity]');
      const minimum = Math.max(1, Math.floor(Number(quantityInput?.min) || 1));
      const quantity = Math.max(minimum, Math.floor(Number(quantityInput?.value) || minimum));
      root.querySelectorAll('[data-whatsapp-link]').forEach((link) => {
        const number = String(link.dataset.whatsappNumber || '').replace(/\D/g, '');
        const canConsultSoldOut = link.dataset.whatsappSoldBehavior === 'consult';
        const disabled = !number || (!variant.available && !canConsultSoldOut);
        const label = link.querySelector('[data-whatsapp-label]');
        if (label) label.textContent = variant.available
          ? (link.dataset.whatsappAvailableLabel || '')
          : (link.dataset.whatsappSoldLabel || root.dataset.soldLabel || '');
        if (disabled) {
          setWhatsappDisabled(link, true);
          return;
        }
        const url = new URL(link.dataset.whatsappUrl || window.location.pathname, window.location.origin);
        url.search = '';
        url.searchParams.set('variant', variant.id);
        const message = replaceTemplate(link.dataset.whatsappTemplate, {
          product: link.dataset.whatsappProduct,
          variant: variant.public_title || (variant.title === 'Default Title' ? root.dataset.singleVariantLabel : variant.title) || '',
          quantity,
          price: formattedPrice,
          url: url.toString()
        });
        link.href = `https://wa.me/${number}?text=${encodeURIComponent(message.trim())}`;
        setWhatsappDisabled(link, false);
      });
    };

    const updateInstallments = (root, variant) => {
      if (!root) return;
      const quantityInput = root.querySelector('[data-product-quantity]');
      const minimum = Math.max(1, Math.floor(Number(quantityInput?.min) || 1));
      const quantity = Math.max(minimum, Math.floor(Number(quantityInput?.value) || minimum));
      const selectionTotal = Math.max(0, (Number(variant?.price) || 0) * quantity);
      root.querySelectorAll('[data-product-installments]').forEach((container) => {
        const count = Math.max(2, Math.floor(Number(container.dataset.installmentCount) || 3));
        const minimum = Math.max(0, Number(container.dataset.installmentMinimum) || 0);
        const preview = container.dataset.installmentPreview === 'true';
        const eligible = Boolean(variant?.available) && selectionTotal >= minimum;
        container.hidden = !preview && !eligible;
        const title = container.querySelector('[data-installment-title]');
        const mobileTitle = container.querySelector('[data-installment-title-mobile]');
        const amount = container.querySelector('[data-installment-amount]');
        if (!title || !variant) return;
        const installmentAmount = Math.round(selectionTotal / count);
        title.textContent = replaceTemplate(container.dataset.installmentTitleTemplate, {
          count,
          amount: money(installmentAmount)
        });
        if (mobileTitle) {
          mobileTitle.textContent = replaceTemplate(container.dataset.installmentMobileTitleTemplate, {
            count,
            amount: money(installmentAmount)
          });
        }
        if (amount) amount.textContent = money(installmentAmount);
      });
    };

    const updateSizeProfile = (root, variant) => {
      if (!root) return;
      root.querySelectorAll('[data-size-profile]').forEach((container) => {
        const source = `${variant?.public_title || variant?.title || ''} ${container.dataset.sizeSource || ''}`.replace(',', '.');
        const match = source.match(/(\d+(?:\.\d+)?)\s*mm\b/i);
        if (!match) {
          container.hidden = true;
          return;
        }
        const size = Number(match[1]);
        if (!Number.isFinite(size)) {
          container.hidden = true;
          return;
        }
        const discreetMax = Number(container.dataset.discreetMax) || 5;
        const balancedMax = Number(container.dataset.balancedMax) || 9;
        let label = container.dataset.boldLabel || '';
        let copy = container.dataset.boldCopy || '';
        if (size <= discreetMax) {
          label = container.dataset.discreetLabel || '';
          copy = container.dataset.discreetCopy || '';
        } else if (size <= balancedMax) {
          label = container.dataset.balancedLabel || '';
          copy = container.dataset.balancedCopy || '';
        }
        const formattedSize = Number.isInteger(size) ? String(size) : String(size).replace('.', ',');
        const value = container.querySelector('[data-size-profile-value]');
        const labelNode = container.querySelector('[data-size-profile-label]');
        const copyNode = container.querySelector('[data-size-profile-copy]');
        if (value) value.textContent = `${formattedSize} mm`;
        if (labelNode) labelNode.textContent = label;
        if (copyNode) copyNode.textContent = copy;
        container.hidden = false;
      });
    };

    const addBusinessDays = (date, days) => {
      const result = new Date(date);
      let remaining = Math.max(0, Math.floor(days));
      while (remaining > 0) {
        result.setDate(result.getDate() + 1);
        const weekday = result.getDay();
        if (weekday !== 0 && weekday !== 6) remaining -= 1;
      }
      return result;
    };

    const limaToday = () => {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Lima',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).formatToParts(new Date());
      const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
      return new Date(Number(values.year), Number(values.month) - 1, Number(values.day), 12);
    };

    const updateDeliveryEstimate = (root, variant) => {
      if (!root) return;
      root.querySelectorAll('[data-delivery-estimate]').forEach((container) => {
        const dateNode = container.querySelector('[data-delivery-date]');
        const available = Boolean(variant?.available);
        container.classList.toggle('is-unavailable', !available);
        if (!dateNode) return;
        if (!available) {
          dateNode.textContent = container.dataset.unavailableText || '';
          return;
        }
        const minimumDays = Math.max(1, Number(container.dataset.minDays) || 1);
        const maximumDays = Math.max(minimumDays, Number(container.dataset.maxDays) || 3);
        const today = limaToday();
        const start = addBusinessDays(today, minimumDays);
        const end = addBusinessDays(today, maximumDays);
        const formatter = new Intl.DateTimeFormat('es-PE', { weekday: 'short', day: 'numeric', month: 'short' });
        const cleanDate = (value) => formatter.format(value).replace(/\./g, '').replace(',', '');
        dateNode.textContent = replaceTemplate(container.dataset.dateTemplate, {
          start: cleanDate(start),
          end: cleanDate(end)
        });
      });
    };

    const updateShippingProgress = (root, cart) => {
      if (!root) return;
      if (cart) root.currentCart = cart;
      const activeCart = root.currentCart;
      const quantityInput = root.querySelector('[data-product-quantity]');
      const minimum = Math.max(1, Math.floor(Number(quantityInput?.min) || 1));
      const quantity = Math.max(minimum, Math.floor(Number(quantityInput?.value) || minimum));
      const selectionTotal = root.currentVariant?.available
        ? Math.max(0, (Number(root.currentVariant.price) || 0) * quantity)
        : 0;
      root.querySelectorAll('[data-shipping-progress]').forEach((container) => {
        const threshold = Number(container.dataset.threshold) || 0;
        const hasCartTotal = activeCart && Number.isFinite(Number(activeCart.total_price));
        const cartTotal = Math.max(0, hasCartTotal
          ? Number(activeCart.total_price)
          : (Number(container.dataset.initialCartTotal) || 0));
        const total = container.dataset.calculation === 'projected' ? cartTotal + selectionTotal : cartTotal;
        const remaining = Math.max(0, threshold - total);
        const percentage = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 100;
        const message = container.querySelector('[data-shipping-progress-message]');
        const bar = container.querySelector('[data-shipping-progress-bar]');
        const progress = container.querySelector('[role="progressbar"]');
        if (message) {
          message.textContent = remaining === 0
            ? container.dataset.unlockedText
            : replaceTemplate(container.dataset.remainingTemplate, { amount: money(remaining) });
        }
        if (bar) bar.style.width = `${percentage}%`;
        if (progress) {
          progress.setAttribute('aria-valuemax', String(threshold));
          progress.setAttribute('aria-valuenow', String(Math.min(total, threshold)));
          progress.setAttribute('aria-valuetext', message?.textContent || '');
        }
        container.classList.toggle('is-unlocked', remaining === 0);
      });
    };

    const visibleMediaItems = (root) => Array.from(root.querySelectorAll('[data-media-item]')).filter((item) => !item.hidden);

    const setActiveMedia = (root, id) => {
      const activeId = String(id || '');
      const activeMedia = root.querySelector(`[data-media-item="${CSS.escape(activeId)}"]`);
      if (!activeMedia || activeMedia.hidden) return;
      const gallery = root.querySelector('[data-product-media]');
      if (gallery) gallery.dataset.activeMedia = activeId;
      root.querySelectorAll('[data-media-item]').forEach((item) => {
        const active = item === activeMedia;
        item.classList.toggle('is-gallery-active', active);
        item.inert = mobileQuery.matches && !active;
        if (mobileQuery.matches) item.setAttribute('aria-hidden', String(!active));
        else item.removeAttribute('aria-hidden');
      });
      root.querySelectorAll('[data-media-thumb]').forEach((button) => {
        const active = button.dataset.mediaThumb === activeId;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-current', String(active));
      });
      if (!mobileQuery.matches && root.classList.contains('main-product--gallery-slider')) {
        const rail = root.querySelector('[data-media-thumbnails]');
        const thumb = rail?.querySelector('[aria-current="true"]');
        if (rail && thumb) {
          const railRect = rail.getBoundingClientRect();
          const thumbRect = thumb.getBoundingClientRect();
          const offset = thumbRect.left + thumbRect.width / 2 - railRect.left - rail.clientWidth / 2;
          const target = Math.max(0, Math.min(Math.max(0, rail.scrollWidth - rail.clientWidth), rail.scrollLeft + offset));
          if (Math.abs(target - rail.scrollLeft) > 1) rail.scrollTo({ left: target, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
        }
      }
      const currentIndex = activeMedia?.dataset.mediaIndex || '1';
      const total = root.querySelector('[data-product-media]')?.dataset.mediaTotal || root.querySelectorAll('[data-media-item]').length;
      root.querySelectorAll('[data-media-current]').forEach((current) => { current.textContent = currentIndex; });
      root.querySelectorAll('[data-media-counter]').forEach((counter) => {
        counter.setAttribute('aria-label', replaceTemplate(counter.dataset.counterTemplate, { current: currentIndex, total }));
      });
      root.querySelectorAll('[data-media-item] video').forEach((video) => {
        if (!video.closest('[data-media-item]')?.isSameNode(activeMedia)) video.pause();
      });
      root.querySelectorAll('[data-media-item] iframe').forEach((frame) => {
        if (frame.closest('[data-media-item]')?.isSameNode(activeMedia)) return;
        frame.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*');
        frame.contentWindow?.postMessage(JSON.stringify({ method: 'pause' }), '*');
      });
    };

    const scrollMediaTrack = (root, item, instant = false) => {
      const track = root.querySelector('[data-media-track]');
      if (!track || !item || item.hidden) return;
      if (mobileQuery.matches) return;
      const left = track.scrollLeft + item.getBoundingClientRect().left - track.getBoundingClientRect().left;
      if (!instant) {
        root.productMediaSelectionToken = (root.productMediaSelectionToken || 0) + 1;
        root.productMediaSyncPending = false;
        track.scrollTo({ left, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
        return;
      }
      const selectionToken = (root.productMediaSelectionToken || 0) + 1;
      root.productMediaSelectionToken = selectionToken;
      root.productMediaSyncPending = true;
      track.scrollTo({ left, behavior: 'instant' });
      window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
        if (selectionToken !== root.productMediaSelectionToken) return;
        root.productMediaSyncPending = false;
        setActiveMedia(root, item.dataset.mediaItem);
      }));
    };

    const scrollToMedia = (root, item) => {
      if (!item || item.hidden) return;
      const request = (root.productMediaRequest || 0) + 1;
      root.productMediaRequest = request;
      root.productMediaRequestedId = item.dataset.mediaItem;
      const show = () => {
        if (!root.isConnected || root.productMediaRequest !== request || item.hidden) return;
        root.productMediaZoomReset?.();
        const desktopNavigation = root.querySelector('.product-media__navigation--desktop');
        if (desktopNavigation && desktopNavigation.parentElement !== item) item.append(desktopNavigation);
        if (!mobileQuery.matches) {
          if (root.classList.contains('main-product--gallery-slider')) scrollMediaTrack(root, item, true);
          else item.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
        }
        setActiveMedia(root, item.dataset.mediaItem);
      };
      const image = item.querySelector('img.product-media__asset');
      if (!image || (image.complete && image.naturalWidth > 0)) {
        show();
        return;
      }
      image.loading = 'eager';
      if (typeof image.decode === 'function') image.decode().then(show).catch(() => {
        if (image.complete && image.naturalWidth > 0) show();
      });
      else image.addEventListener('load', show, { once: true });
    };

    const selectVariantMedia = (root, item) => {
      if (!item || item.hidden) return;
      root.querySelectorAll('[data-media-item]').forEach((media) => media.classList.toggle('is-variant-media', media === item));
      scrollToMedia(root, item);
    };

    const updateVariant = (root, variant, { updateMedia = true } = {}) => {
      if (!root) return;
      const previousVariant = root.currentVariant;
      root.removeAttribute('aria-busy');
      if (!variant) {
        root.currentVariant = null;
        root.querySelectorAll('[data-product-variant-id]').forEach((input) => { input.value = ''; });
        const availability = root.querySelector('[data-product-availability]');
        const availabilityText = availability?.querySelector('[data-availability-text]');
        availability?.classList.add('is-unavailable');
        if (availabilityText) availabilityText.textContent = root.dataset.unavailableLabel;
        root.querySelectorAll('button[name="add"]').forEach((button) => {
          button.disabled = true;
          button.dataset.variantAvailable = 'false';
          const label = button.querySelector('[data-add-to-cart-text]');
          if (label) label.textContent = root.dataset.unavailableLabel;
        });
        const skuRow = root.querySelector('[data-product-sku-row]');
        if (skuRow) skuRow.hidden = true;
        const discount = root.querySelector('[data-variant-discount]');
        if (discount) discount.hidden = true;
        root.querySelectorAll('[data-whatsapp-link]').forEach((link) => setWhatsappDisabled(link, true));
        updateInstallments(root, null);
        updateShippingProgress(root);
        updateSizeProfile(root, null);
        updateDeliveryEstimate(root, null);
        return;
      }
      root.currentVariant = variant;
      root.querySelectorAll('[data-product-variant-id]').forEach((variantIdInput) => {
        variantIdInput.name = 'id';
        variantIdInput.value = String(variant.id);
      });
      const current = root.querySelector('.main-product__price .price__current');
      let compare = root.querySelector('.main-product__price .price__compare');
      const price = money(variant.price);
      if (current) current.textContent = price;
      if (!compare && variant.compare_at_price > variant.price) {
        compare = document.createElement('s');
        compare.className = 'price__compare';
        root.querySelector('.main-product__price')?.append(compare);
      }
      if (compare) {
        compare.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
        compare.hidden = !(variant.compare_at_price > variant.price);
      }
      const discount = root.querySelector('[data-variant-discount]');
      const hasDiscount = Number(variant.compare_at_price) > Number(variant.price);
      if (discount) {
        const percentage = hasDiscount ? Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) : 0;
        const savingAmount = discount.querySelector('[data-variant-saving]');
        const savingPercentage = discount.querySelector('[data-variant-percent]');
        if (savingAmount) savingAmount.textContent = hasDiscount ? money(variant.compare_at_price - variant.price) : '';
        if (savingPercentage) savingPercentage.textContent = `${percentage}%`;
        discount.hidden = !hasDiscount;
      }
      const live = root.querySelector('[data-price-live]');
      if (live) live.textContent = price;
      root.querySelectorAll('[data-sticky-price]').forEach((element) => { element.textContent = price; });

      const sku = root.querySelector('[data-product-sku]');
      const skuRow = root.querySelector('[data-product-sku-row]');
      if (sku) sku.textContent = variant.sku || '';
      if (skuRow) skuRow.hidden = !variant.sku;

      const availability = root.querySelector('[data-product-availability]');
      const availabilityText = availability?.querySelector('[data-availability-text]');
      availability?.classList.toggle('is-unavailable', !variant.available);
      if (availabilityText) availabilityText.textContent = variant.available ? root.dataset.inStockLabel : root.dataset.outOfStockLabel;

      root.querySelectorAll('button[name="add"]').forEach((button) => {
        button.disabled = !variant.available;
        button.dataset.variantAvailable = String(Boolean(variant.available));
        const hasPurchaseState = button.classList.contains('is-loading')
          || button.classList.contains('is-success')
          || button.classList.contains('is-error');
        if (!hasPurchaseState) setAddButtonState(button, 'idle', root);
      });

      updateWhatsapp(root, variant, price);
      updateInstallments(root, variant);
      updateShippingProgress(root);
      updateSizeProfile(root, variant);
      updateDeliveryEstimate(root, variant);

      const mediaId = variant.featured_media?.id || variant.featured_image?.id;
      const previousMediaId = previousVariant?.featured_media?.id || previousVariant?.featured_image?.id;
      const featuredMediaChanged = String(mediaId || '') !== String(previousMediaId || '');
      if (updateMedia && featuredMediaChanged) {
        const media = mediaId
          ? root.querySelector(`[data-media-item="${CSS.escape(String(mediaId))}"]`)
          : null;
        selectVariantMedia(root, media && !media.hidden ? media : visibleMediaItems(root)[0]);
      }
    };

    const selectedVariantFor = (root) => {
      const picker = root.querySelector('variant-picker');
      const variants = root.productVariantCache || picker?.variantCache || [];
      const candidates = variants.length || root.productPricesRefreshed
        ? variants
        : [root.currentVariant, root.productSelectedVariant].filter(Boolean);
      const groups = Array.from(picker?.querySelectorAll('[data-option-position]') || []);
      if (groups.length) {
        const options = groups.map((group) => group.querySelector('input:checked, select')?.value || '');
        return candidates.find((variant) => variant.options?.length === options.length
          && variant.options.every((option, index) => option === options[index])) || null;
      }
      const selectedId = root.querySelector('[data-product-variant-id]')?.value;
      return candidates.find((variant) => String(variant.id) === String(selectedId)) || null;
    };

    const syncSelectedVariant = (root) => {
      if (root.getAttribute('aria-busy') === 'true') return null;
      const variant = selectedVariantFor(root);
      updateVariant(root, variant, { updateMedia: false });
      const picker = root.querySelector('variant-picker');
      picker?.querySelectorAll('[data-option-position]').forEach((group) => {
        const selected = group.querySelector('input:checked, select');
        const output = group.querySelector('[data-selected-option]');
        if (selected && output) output.textContent = selected.value;
      });
      if (variant && typeof picker?.updateOptionAvailability === 'function') {
        picker.updateOptionAvailability(root.productVariantCache || [], variant.options || []);
      }
      return variant;
    };

    const refreshProductPrices = (root) => {
      if (Number(root.dataset.productVariantCount) > 250) return Promise.resolve();
      if (root.productPricesRequest) return root.productPricesRequest;
      if (Date.now() - (root.productPricesLastRequested || 0) < 2000) return Promise.resolve();
      const productUrl = root.dataset.productUrl || root.querySelector('variant-picker')?.dataset.productUrl;
      if (!productUrl) return Promise.resolve();
      const url = new URL(productUrl, window.location.origin);
      if (url.origin !== window.location.origin) return Promise.resolve();
      url.pathname = `${url.pathname.replace(/\/$/, '')}.js`;
      url.search = '';
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 6000);
      root.productPricesLastRequested = Date.now();
      root.productPricesRequest = (async () => {
        try {
          const response = await fetch(url, {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' },
            signal: controller.signal
          });
          if (!response.ok) return;
          const product = await response.json();
          if (!root.isConnected || !Array.isArray(product.variants)) return;
          if (product.variants.some((variant) => !variant.id || !Number.isFinite(Number(variant.price)))) return;
          const previous = new Map((root.productVariantCache || []).map((variant) => [String(variant.id), variant]));
          root.productVariantCache = product.variants.map((variant) => ({ ...previous.get(String(variant.id)), ...variant }));
          root.productPricesRefreshed = true;
          const picker = root.querySelector('variant-picker');
          if (picker) picker.variantCache = root.productVariantCache;
          syncSelectedVariant(root);
        } catch (error) {
        } finally {
          window.clearTimeout(timeout);
          root.productPricesRequest = null;
        }
      })();
      return root.productPricesRequest;
    };

    const resumeProductPrices = () => {
      if (document.hidden) return;
      document.querySelectorAll('[data-main-product]').forEach((root) => {
        syncSelectedVariant(root);
        refreshProductPrices(root);
      });
    };

    const initializeGallery = (root) => {
      const track = root.querySelector('[data-media-track]');
      if (!track) return;
      const gallery = root.querySelector('[data-product-media]');
      const move = (direction) => {
        const items = visibleMediaItems(root);
        if (!items.length) return;
        const active = root.querySelector('[data-media-thumb][aria-current="true"]');
        const activeId = root.productMediaRequestedId || active?.dataset.mediaThumb;
        const activeIndex = Math.max(0, items.findIndex((item) => item.dataset.mediaItem === activeId));
        const nextIndex = (activeIndex + direction + items.length) % items.length;
        scrollToMedia(root, items[nextIndex]);
      };
      root.querySelectorAll('[data-media-previous]').forEach((button) => button.addEventListener('click', () => move(-1)));
      root.querySelectorAll('[data-media-next]').forEach((button) => button.addEventListener('click', () => move(1)));
      root.querySelectorAll('[data-media-thumb]').forEach((button) => {
        button.addEventListener('click', () => {
          const target = root.querySelector(`[data-media-item="${CSS.escape(button.dataset.mediaThumb || '')}"]`);
          scrollToMedia(root, target);
        });
      });

      let frame;
      track.addEventListener('scroll', () => {
        if (mobileQuery.matches || !root.classList.contains('main-product--gallery-slider')) return;
        window.cancelAnimationFrame(frame);
        if (root.productMediaSyncPending) return;
        frame = window.requestAnimationFrame(() => {
          if (root.productMediaSyncPending) return;
          const center = track.getBoundingClientRect().left + (track.clientWidth / 2);
          let closest;
          let distance = Infinity;
          visibleMediaItems(root).forEach((item) => {
            const rect = item.getBoundingClientRect();
            const itemDistance = Math.abs((rect.left + (rect.width / 2)) - center);
            if (itemDistance < distance) {
              distance = itemDistance;
              closest = item;
            }
          });
          if (closest && closest.dataset.mediaItem !== gallery?.dataset.activeMedia) {
            root.productMediaRequestedId = closest.dataset.mediaItem;
            setActiveMedia(root, closest.dataset.mediaItem);
          }
        });
      }, { passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      });
      let swipe;
      let suppressSwipeClick = false;
      const galleryController = new AbortController();
      const gallerySignal = galleryController.signal;
      track.addEventListener('pointerdown', (event) => {
        if (!mobileQuery.matches || !event.isPrimary || event.button !== 0) return;
        if (event.target.closest('video, iframe, model-viewer, .is-inline-zoom, [data-media-zoom-close]')) return;
        swipe = { id: event.pointerId, x: event.clientX, y: event.clientY };
      }, { passive: true });
      track.addEventListener('pointerup', (event) => {
        if (!swipe || swipe.id !== event.pointerId) return;
        const dx = event.clientX - swipe.x;
        const dy = event.clientY - swipe.y;
        swipe = undefined;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
        suppressSwipeClick = true;
        move(dx < 0 ? 1 : -1);
        window.setTimeout(() => { suppressSwipeClick = false; }, 400);
      });
      track.addEventListener('pointercancel', () => { swipe = undefined; }, { passive: true });
      track.addEventListener('click', (event) => {
        if (!suppressSwipeClick) return;
        suppressSwipeClick = false;
        event.preventDefault();
        event.stopPropagation();
      }, { capture: true });
      const syncGalleryViewport = () => {
        const item = root.querySelector(`[data-media-item="${CSS.escape(gallery?.dataset.activeMedia || '')}"]`);
        if (!item) return;
        root.productMediaZoomReset?.();
        setActiveMedia(root, item.dataset.mediaItem);
        if (!mobileQuery.matches && root.classList.contains('main-product--gallery-slider')) scrollMediaTrack(root, item, true);
      };
      window.addEventListener('resize', syncGalleryViewport, { passive: true, signal: gallerySignal });
      root.productMediaGalleryCleanup = () => {
        galleryController.abort();
        root.productMediaRequest = (root.productMediaRequest || 0) + 1;
        window.cancelAnimationFrame(frame);
      };
      const initialMediaId = root.querySelector('[data-product-media]')?.dataset.activeMedia;
      const initialItem = initialMediaId ? root.querySelector(`[data-media-item="${CSS.escape(initialMediaId)}"]`) : null;
      const firstItem = initialItem && !initialItem.hidden ? initialItem : visibleMediaItems(root)[0];
      if (firstItem) setActiveMedia(root, firstItem.dataset.mediaItem);
      if (firstItem && (mobileQuery.matches || root.classList.contains('main-product--gallery-slider'))) scrollMediaTrack(root, firstItem, true);
    };

    const initializeInlineZoom = (root) => {
      const triggers = Array.from(root.querySelectorAll('[data-media-zoom-open]'));
      if (!triggers.length) return;
      let activeTrigger;
      let gesture;
      let suppressClick = false;
      let suppressTimer;
      const clamp = (value) => Math.max(0, Math.min(100, value));

      const resetZoom = (restoreFocus = false) => {
        if (!activeTrigger) return;
        const trigger = activeTrigger;
        const item = trigger.closest('[data-media-item]');
        activeTrigger = undefined;
        gesture = undefined;
        item?.classList.remove('is-inline-zoom');
        trigger.style.removeProperty('--inline-zoom-x');
        trigger.style.removeProperty('--inline-zoom-y');
        trigger.setAttribute('aria-pressed', 'false');
        trigger.setAttribute('aria-label', trigger.dataset.zoomLabel);
        const close = item?.querySelector('[data-media-zoom-close]');
        if (close) close.hidden = true;
        if (restoreFocus && trigger.isConnected) trigger.focus({ preventScroll: true });
      };

      const focalFromPoint = (trigger, clientX, clientY) => {
        const rect = trigger.getBoundingClientRect();
        return {
          x: clamp(((clientX - rect.left) / rect.width) * 100),
          y: clamp(((clientY - rect.top) / rect.height) * 100)
        };
      };

      const setFocal = (trigger, focal) => {
        trigger.style.setProperty('--inline-zoom-x', `${focal.x}%`);
        trigger.style.setProperty('--inline-zoom-y', `${focal.y}%`);
      };

      triggers.forEach((trigger) => {
        const item = trigger.closest('[data-media-item]');
        const close = item?.querySelector('[data-media-zoom-close]');
        trigger.addEventListener('click', (event) => {
          if (suppressClick) {
            suppressClick = false;
            return;
          }
          if (activeTrigger === trigger) {
            resetZoom();
            return;
          }
          resetZoom();
          activeTrigger = trigger;
          item?.classList.add('is-inline-zoom');
          trigger.setAttribute('aria-pressed', 'true');
          trigger.setAttribute('aria-label', trigger.dataset.closeLabel);
          if (close) close.hidden = false;
          setFocal(trigger, event.detail > 0 ? focalFromPoint(trigger, event.clientX, event.clientY) : { x: 50, y: 50 });
          const asset = trigger.querySelector('img');
          if (asset && !asset.dataset.zoomUpgraded && trigger.dataset.zoomSrc) {
            asset.dataset.zoomUpgraded = 'pending';
            const highResolution = new Image();
            highResolution.onload = () => {
              if (!asset.isConnected) return;
              asset.srcset = '';
              asset.src = trigger.dataset.zoomSrc;
              asset.dataset.zoomUpgraded = 'true';
            };
            highResolution.onerror = () => { delete asset.dataset.zoomUpgraded; };
            highResolution.src = trigger.dataset.zoomSrc;
          }
        });
        close?.addEventListener('click', () => resetZoom(true));

        trigger.addEventListener('pointerdown', (event) => {
          if (activeTrigger !== trigger || event.pointerType === 'mouse' || !event.isPrimary) return;
          gesture = {
            id: event.pointerId,
            x: event.clientX,
            y: event.clientY,
            focal: focalFromPoint(trigger, event.clientX, event.clientY),
            moved: false
          };
          trigger.setPointerCapture(event.pointerId);
        });
        trigger.addEventListener('pointermove', (event) => {
          if (activeTrigger !== trigger) return;
          if (event.pointerType === 'mouse') {
            setFocal(trigger, focalFromPoint(trigger, event.clientX, event.clientY));
            return;
          }
          if (!gesture || gesture.id !== event.pointerId) return;
          const deltaX = event.clientX - gesture.x;
          const deltaY = event.clientY - gesture.y;
          if (Math.hypot(deltaX, deltaY) > 8) gesture.moved = true;
          if (!gesture.moved) return;
          const rect = trigger.getBoundingClientRect();
          setFocal(trigger, {
            x: clamp(gesture.focal.x - (deltaX / rect.width) * 67),
            y: clamp(gesture.focal.y - (deltaY / rect.height) * 67)
          });
        });
        const endGesture = (event) => {
          if (!gesture || gesture.id !== event.pointerId) return;
          if (gesture.moved && event.type === 'pointerup') {
            suppressClick = true;
            window.clearTimeout(suppressTimer);
            suppressTimer = window.setTimeout(() => { suppressClick = false; }, 500);
          }
          gesture = undefined;
        };
        trigger.addEventListener('pointerup', endGesture);
        trigger.addEventListener('pointercancel', endGesture);
      });

      const onKeyDown = (event) => {
        if (event.key !== 'Escape' || !activeTrigger) return;
        event.preventDefault();
        resetZoom(true);
      };
      document.addEventListener('keydown', onKeyDown);
      root.productMediaZoomReset = resetZoom;
      root.productMediaZoomCleanup = () => {
        document.removeEventListener('keydown', onKeyDown);
        window.clearTimeout(suppressTimer);
        resetZoom();
      };
    };

    const syncMobileStickyClasses = () => {
      const sticky = Array.from(document.querySelectorAll('[data-mobile-sticky]')).find((item) => (
        mobileQuery.matches && !item.hidden && item.getClientRects().length > 0
      ));
      document.documentElement.classList.toggle('product-page-has-mobile-buy', Boolean(sticky));
      document.documentElement.classList.toggle(
        'product-page-mobile-buy-actions-only',
        Boolean(sticky?.classList.contains('main-product__mobile-sticky--actions-only'))
      );
    };

    const initializeStickyBuy = (root) => {
      const sticky = root.querySelector('[data-mobile-sticky]');
      if (!sticky) return;
      let frame;
      const sync = () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(() => {
          if (!mobileQuery.matches) {
            sticky.hidden = true;
            syncMobileStickyClasses();
            return;
          }
          const action = sticky.dataset.stickyAction;
          const areaSelector = action === 'cart'
            ? '[data-add-to-cart-block]'
            : action === 'whatsapp'
              ? '[data-whatsapp-buy-area]'
              : '[data-add-to-cart-block], [data-whatsapp-buy-area]';
          let buyAreas = Array.from(root.querySelectorAll(areaSelector)).filter((item) => item.getClientRects().length > 0);
          if (!buyAreas.length) {
            const independentReference = root.querySelector('.main-product__info') || root.querySelector('.main-product__media-column');
            buyAreas = independentReference && independentReference.getClientRects().length ? [independentReference] : [];
          }
          if (!buyAreas.length) {
            sticky.hidden = true;
            syncMobileStickyClasses();
            return;
          }
          const buyRects = buyAreas.map((item) => item.getBoundingClientRect());
          const buyVisible = buyRects.some((rect) => rect.bottom > 80 && rect.top < window.innerHeight - 80);
          const passedBuyArea = buyRects.every((rect) => rect.bottom < 80);
          const footer = document.querySelector('.shopify-section-group-footer-group, .ll-footer');
          const footerIsNear = footer ? footer.getBoundingClientRect().top < window.innerHeight - 20 : false;
          sticky.hidden = !(passedBuyArea && !buyVisible && !footerIsNear);
          syncMobileStickyClasses();
        });
      };
      const controller = new AbortController();
      root.productStickyController = controller;
      window.addEventListener('scroll', sync, { passive: true, signal: controller.signal });
      window.addEventListener('resize', sync, { passive: true, signal: controller.signal });
      mobileQuery.addEventListener('change', sync, { signal: controller.signal });
      sync();
    };

    const initialize = (root) => {
      if (root.dataset.productReady === 'true') return;
      root.dataset.productReady = 'true';
      root.querySelectorAll('[data-product-variant-id]').forEach((variantIdInput) => { variantIdInput.name = 'id'; });
      const picker = root.querySelector('variant-picker');
      const variantsData = root.querySelector('[data-product-variants]');
      try {
        root.productVariantCache = JSON.parse(variantsData?.textContent || '[]');
      } catch (error) {
        root.productVariantCache = [];
      }
      if (picker) picker.variantCache = root.productVariantCache;
      initializeGallery(root);
      initializeInlineZoom(root);
      initializeStickyBuy(root);
      const productForm = root.querySelector('.main-product__form--controller');
      productForm?.addEventListener('submit', (event) => {
        const submitter = event.submitter instanceof HTMLButtonElement
          ? event.submitter
          : root.querySelector('button[name="add"]');
        if (!submitter || submitter.disabled || submitter.name !== 'add') return;
        setAddButtonState(submitter, 'loading', root);
      });
      root.querySelectorAll('[data-scroll-size-guide]').forEach((button) => {
        button.addEventListener('click', () => {
          const guide = document.querySelector('[data-size-guide]');
          if (!guide) return;
          guide.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
        });
      });
      root.addEventListener('input', (event) => {
        if (!event.target.matches('[name="quantity"]')) return;
        if (root.currentVariant) {
          updateWhatsapp(root, root.currentVariant, money(root.currentVariant.price));
          updateInstallments(root, root.currentVariant);
          updateShippingProgress(root);
        }
      });
      root.addEventListener('change', (event) => {
        if (!event.target.matches('[name="quantity"]')) return;
        const minimum = Math.max(1, Math.floor(Number(event.target.min) || 1));
        const maximum = Number(event.target.max);
        const requested = Math.max(minimum, Math.floor(Number(event.target.value) || minimum));
        event.target.value = String(Number.isFinite(maximum) && maximum >= minimum ? Math.min(requested, maximum) : requested);
        if (root.currentVariant) {
          updateWhatsapp(root, root.currentVariant, money(root.currentVariant.price));
          updateInstallments(root, root.currentVariant);
          updateShippingProgress(root);
        }
      });
      try {
        const selectedData = picker?.querySelector('[data-selected-variant]');
        root.productSelectedVariant = selectedData ? JSON.parse(selectedData.textContent) : null;
        syncSelectedVariant(root);
      } catch (error) {
        // Server-rendered price and availability remain the progressive fallback.
      }
      root.addEventListener('click', (event) => {
        const link = event.target.closest?.('[data-whatsapp-link]');
        if (!link || !root.contains(link)) return;
        const variant = syncSelectedVariant(root);
        if (!variant || link.getAttribute('aria-disabled') === 'true' || !link.hasAttribute('href')) {
          event.preventDefault();
        }
      }, { capture: true });
      updateShippingProgress(root);
      refreshProductPrices(root);
      const cartRequest = window.LionTheme?.cart?.get?.();
      if (cartRequest && typeof cartRequest.then === 'function') {
        cartRequest.then((cart) => updateShippingProgress(root, cart)).catch(() => {});
      }
    };

    document.querySelectorAll('[data-main-product]').forEach(initialize);
    document.addEventListener('lion:variant:changed', (event) => {
      const root = event.detail?.picker?.closest('[data-main-product]');
      const variant = event.detail?.variant;
      const current = variant && root?.productVariantCache?.find((item) => String(item.id) === String(variant.id));
      updateVariant(root, current || (root?.productPricesRefreshed ? null : variant));
    });
    window.addEventListener('pageshow', resumeProductPrices);
    window.addEventListener('focus', resumeProductPrices);
    document.addEventListener('visibilitychange', resumeProductPrices);
    document.addEventListener('lion:cart:updated', (event) => {
      const cart = event.detail?.cart;
      if (cart && Number.isFinite(Number(cart.total_price))) {
        document.querySelectorAll('[data-main-product]').forEach((root) => updateShippingProgress(root, cart));
        return;
      }
      const cartRequest = window.LionTheme?.cart?.get?.();
      if (cartRequest && typeof cartRequest.then === 'function') {
        cartRequest
          .then((freshCart) => document.querySelectorAll('[data-main-product]').forEach((root) => updateShippingProgress(root, freshCart)))
          .catch(() => document.querySelectorAll('[data-main-product]').forEach((root) => updateShippingProgress(root)));
        return;
      }
      document.querySelectorAll('[data-main-product]').forEach((root) => updateShippingProgress(root));
    });
    document.addEventListener('lion:product:added', (event) => {
      const submitter = event.detail?.submitter;
      const root = submitter?.closest?.('[data-main-product]') || event.detail?.form?.closest?.('[data-main-product]');
      if (!root) return;
      const busyButtons = Array.from(root.querySelectorAll('button[name="add"]')).filter((button) => (
        button.classList.contains('is-loading') || button.getAttribute('aria-busy') === 'true'
      ));
      const buttons = submitter instanceof HTMLButtonElement
        ? [submitter]
        : (busyButtons.length ? busyButtons : Array.from(root.querySelectorAll('button[name="add"]')));
      buttons.forEach((button) => {
        setAddButtonState(button, 'idle', root);
      });
    });
    document.addEventListener('lion:cart:error', (event) => {
      const submitter = event.detail?.submitter;
      const root = submitter?.closest?.('[data-main-product]') || event.detail?.form?.closest?.('[data-main-product]');
      if (!root) return;
      const busyButtons = Array.from(root.querySelectorAll('button[name="add"]')).filter((button) => (
        button.classList.contains('is-loading') || button.getAttribute('aria-busy') === 'true'
      ));
      const buttons = submitter instanceof HTMLButtonElement
        ? [submitter]
        : (busyButtons.length ? busyButtons : Array.from(root.querySelectorAll('button[name="add"]')));
      buttons.forEach((button) => {
        setAddButtonState(button, 'error', root);
        resetAddButtonLater(button, root, 2200);
      });
    });
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-main-product]').forEach(initialize);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-main-product]').forEach((root) => {
        root.productStickyController?.abort();
        root.productMediaZoomCleanup?.();
        root.productMediaGalleryCleanup?.();
      });
      document.documentElement.classList.remove('product-page-has-mobile-buy', 'product-page-mobile-buy-actions-only');
      window.requestAnimationFrame(syncMobileStickyClasses);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (() => {
    const initializeSearchPagination = (root) => {
      if (!root || root.dataset.paginationReady === 'true') return;
      root.dataset.paginationReady = 'true';
      let pageActive = true;
      let requestGeneration = 0;
      let pendingRequest = null;
      const cancelPendingRequest = () => {
        requestGeneration += 1;
        const request = pendingRequest;
        pendingRequest = null;
        if (!request) return;
        window.clearTimeout(request.timer);
        request.controller.abort();
        request.cancel?.();
        request.link.removeAttribute('aria-busy');
      };
      window.addEventListener('pagehide', () => {
        pageActive = false;
        cancelPendingRequest();
      });
      window.addEventListener('pageshow', (event) => {
        if (!event.persisted || !root.isConnected) return;
        pageActive = true;
        cancelPendingRequest();
        root.querySelectorAll('[data-search-load-more]').forEach((link) => link.removeAttribute('aria-busy'));
      });
      root.addEventListener('click', async (event) => {
        const link = event.target.closest('[data-search-load-more]');
        if (!link || !root.contains(link)) return;
        if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.defaultPrevented) return;
        event.preventDefault();
        if (!pageActive || pendingRequest || link.getAttribute('aria-busy') === 'true') return;
        const request = {
          controller: new AbortController(),
          generation: ++requestGeneration,
          link
        };
        pendingRequest = request;
        link.setAttribute('aria-busy', 'true');
        const status = root.querySelector('[data-search-load-status]');
        if (status) {
          status.classList.add('visually-hidden');
          status.textContent = '';
        }

        try {
          const interrupted = new Promise((resolve, reject) => {
            request.cancel = () => reject(new Error('Search pagination cancelled'));
            request.timer = window.setTimeout(() => {
              request.controller.abort();
              reject(new Error('Search pagination timed out'));
            }, 20000);
          });
          const html = await Promise.race([
            (async () => {
              const response = await fetch(link.href, {
                headers: { Accept: 'text/html' },
                signal: request.controller.signal
              });
              if (!response.ok) throw new Error(String(response.status));
              return response.text();
            })(),
            interrupted
          ]);
          if (!pageActive || pendingRequest !== request || request.generation !== requestGeneration || !root.isConnected) return;
          const nextDocument = new DOMParser().parseFromString(html, 'text/html');
          const nextRoot = nextDocument.querySelector('[data-main-search]');
          const nextItems = nextRoot?.querySelectorAll('[data-search-grid-item]') || [];
          const nextLink = nextRoot?.querySelector('[data-search-load-more]');
          const grid = root.querySelector('[data-search-grid]');
          if (!grid || !nextItems.length) throw new Error('Missing search results');
          nextItems.forEach((item) => grid.append(item));
          if (status) status.textContent = status.dataset.loadedLabel.replace('[count]', String(nextItems.length));
          if (nextLink) {
            link.href = nextLink.href;
          } else link.remove();
        } catch (error) {
          if (!pageActive || pendingRequest !== request || request.generation !== requestGeneration || !root.isConnected) return;
          if (status) {
            status.textContent = status.dataset.errorLabel;
            status.classList.remove('visually-hidden');
          }
        } finally {
          window.clearTimeout(request.timer);
          if (pendingRequest === request) {
            pendingRequest = null;
            link.removeAttribute('aria-busy');
          }
        }
      });
    };

    const initializeAll = (scope = document) => scope.querySelectorAll('[data-main-search]').forEach(initializeSearchPagination);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
    else initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-complementary"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loadComplementaryProducts = async (root) => {
      if (root.dataset.source !== 'automatic' || root.dataset.loaded === 'true' || root.dataset.loading === 'true' || !root.dataset.url) return;
      root.dataset.loading = 'true';
      try {
        const response = await fetch(root.dataset.url, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error(String(response.status));
        const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = responseDocument.querySelector('[data-product-complementary]');
        if (!incoming) throw new Error('complementary-products');
        root.innerHTML = incoming.innerHTML;
        root.dataset.loaded = 'true';
        root.dataset.hasProducts = incoming.dataset.hasProducts;
        root.hidden = incoming.dataset.hasProducts !== 'true' && !window.Shopify?.designMode;
        window.LionTheme?.initialize(root);
      } catch (error) {
        root.hidden = !window.Shopify?.designMode;
      } finally {
        delete root.dataset.loading;
      }
    };

    const initialize = (scope = document) => {
      const roots = [];
      if (scope instanceof Element && scope.matches('[data-product-complementary]')) roots.push(scope);
      scope.querySelectorAll?.('[data-product-complementary]').forEach((root) => roots.push(root));
      roots.forEach((root) => {
        if (root.dataset.source !== 'automatic' || root.dataset.loaded === 'true' || root.dataset.observed === 'true') return;
        root.dataset.observed = 'true';
        if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {
          loadComplementaryProducts(root);
          return;
        }
        const observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          loadComplementaryProducts(root);
        }, { rootMargin: '0px 0px 360px 0px' });
        observer.observe(root);
      });
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-materials-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-materials-presentation')) {
    customElements.define('product-materials-presentation', class extends HTMLElement {
      constructor() {
        super();
        this.mobileStates = new WeakMap();
        this.handleMediaChange = this.syncPresentation.bind(this);
        this.handleSummaryClick = this.onSummaryClick.bind(this);
        this.handleSummaryKeydown = this.onSummaryKeydown.bind(this);
      }

      connectedCallback() {
        this.benefits = Array.from(this.querySelectorAll('.product-materials-editorial__benefit'));
        this.querySelectorAll('.product-materials-editorial__benefits').forEach((group) => {
          group.querySelectorAll('.product-materials-editorial__benefit').forEach((benefit, index) => {
            if (!this.mobileStates.has(benefit)) this.mobileStates.set(benefit, index === 0);
          });
        });
        this.mediaQuery = window.matchMedia('(min-width: 990px)');
        this.isDesktop = null;
        this.mediaQuery.addEventListener('change', this.handleMediaChange);
        this.addEventListener('click', this.handleSummaryClick);
        this.addEventListener('keydown', this.handleSummaryKeydown);
        this.syncPresentation();
      }

      disconnectedCallback() {
        if (this.isDesktop === false) this.saveMobileStates();
        if (this.mediaQuery) this.mediaQuery.removeEventListener('change', this.handleMediaChange);
        this.removeEventListener('click', this.handleSummaryClick);
        this.removeEventListener('keydown', this.handleSummaryKeydown);
      }

      saveMobileStates() {
        this.benefits.forEach((benefit) => this.mobileStates.set(benefit, benefit.open));
      }

      syncPresentation() {
        const desktop = this.mediaQuery.matches;
        if (this.isDesktop === desktop) return;
        if (this.isDesktop === false) this.saveMobileStates();
        this.isDesktop = desktop;
        this.benefits.forEach((benefit) => {
          const summary = benefit.querySelector('summary');
          benefit.open = desktop || this.mobileStates.get(benefit);
          if (desktop) {
            summary.setAttribute('tabindex', '-1');
            summary.setAttribute('aria-disabled', 'true');
          } else {
            summary.removeAttribute('tabindex');
            summary.removeAttribute('aria-disabled');
          }
        });
      }

      onSummaryClick(event) {
        if (this.isDesktop && event.target.closest('.product-materials-editorial__benefit-summary')) {
          event.preventDefault();
        }
      }

      onSummaryKeydown(event) {
        if (this.isDesktop && (event.key === 'Enter' || event.key === ' ') && event.target.closest('.product-materials-editorial__benefit-summary')) {
          event.preventDefault();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-purchase-confidence"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!customElements.get('lion-purchase-confidence')) {
      customElements.define('lion-purchase-confidence', class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';
          this.variants = [];
          const variantsNode = this.querySelector('[data-product-variants]');
          if (variantsNode) {
            try {
              this.variants = JSON.parse(variantsNode.textContent);
            } catch (error) {
              this.variants = [];
            }
          }
          this.addEventListener('click', (event) => this.handleClick(event));
          document.addEventListener('change', (event) => {
            if (event.target.matches('form[action*="/cart/add"] [name="id"]')) this.updateVariantState();
          });
          this.updateVariantState();
          this.setupGlobalTracking();
        }

        selectedVariant() {
          const selectedInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
          const selectedId = selectedInput ? String(selectedInput.value) : '';
          return this.variants.find((variant) => String(variant.id) === selectedId) || this.variants[0] || null;
        }

        message(template, zone) {
          const variant = this.selectedVariant();
          const variantTitle = variant && variant.title ? variant.title : '';
          return template
            .replaceAll('[product]', this.dataset.productTitle || '')
            .replaceAll('[variant]', variantTitle)
            .replaceAll('[zone]', zone || '')
            .replaceAll('[url]', window.location.href);
        }

        whatsappUrl(template, zone) {
          return 'https://wa.me/' + this.dataset.whatsappNumber + '?text=' + encodeURIComponent(this.message(template, zone));
        }

        updateVariantState() {
          const variant = this.selectedVariant();
          const available = !variant || variant.available;
          const reserve = this.querySelector('[data-store-reserve]');
          const availability = this.querySelector('[data-store-availability]');
          const label = this.querySelector('[data-availability-label]');
          if (reserve) {
            reserve.href = this.whatsappUrl(this.dataset.reserveTemplate || '', '');
            const reserveText = available ? this.dataset.reserveLabel : this.dataset.unavailableReserveLabel;
            const textNode = Array.from(reserve.childNodes).find((node) => node.nodeType === Node.TEXT_NODE);
            if (textNode) textNode.textContent = reserveText + ' ';
          }
          if (availability) availability.classList.toggle('is-unavailable', !available);
          if (label) label.textContent = available ? label.dataset.availableLabel : label.dataset.unavailableLabel;
          this.querySelectorAll('[data-zone-quote]').forEach((link) => {
            link.href = this.whatsappUrl(this.dataset.quoteTemplate || '', link.dataset.zone || '');
          });
        }

        handleClick(event) {
          const tab = event.target.closest('[data-delivery-tab]');
          if (tab) {
            this.querySelectorAll('[data-delivery-tab]').forEach((item) => {
              const active = item === tab;
              item.setAttribute('aria-selected', active ? 'true' : 'false');
              item.tabIndex = active ? 0 : -1;
            });
            this.querySelectorAll('[data-delivery-panel]').forEach((panel) => {
              panel.hidden = panel.id !== tab.dataset.target;
            });
            this.track('delivery_zone_select', { zone: tab.textContent.trim() });
          }
          if (event.target.closest('[data-store-reserve]')) this.track('store_reservation_click');
          const quote = event.target.closest('[data-zone-quote]');
          if (quote) this.track('delivery_quote_click', { zone: quote.dataset.zone || '' });
        }

        track(action, extra = {}) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'lion_product_action',
            action,
            product_handle: this.dataset.productHandle || '',
            variant_id: this.selectedVariant() ? String(this.selectedVariant().id) : '',
            ...extra
          });
        }

        setupGlobalTracking() {
          if (window.__lionProductTrackingReady) return;
          window.__lionProductTrackingReady = true;
          document.addEventListener('click', (event) => {
            const cartButton = event.target.closest('form[action*="/cart/add"] button[type="submit"]');
            const whatsappLink = event.target.closest('a[href*="wa.me"]');
            if (!cartButton && !whatsappLink) return;
            if (whatsappLink && whatsappLink.matches('[data-store-reserve],[data-zone-quote]')) return;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'lion_product_action',
              action: cartButton ? 'add_to_cart_click' : 'whatsapp_product_click',
              product_handle: this.dataset.productHandle || '',
              variant_id: this.selectedVariant() ? String(this.selectedVariant().id) : ''
            });
          });
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const text = (value, maximum = 240) => typeof value === 'string' ? value.trim().slice(0, maximum) : '';
    const number = (value) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
    };
    const productUrl = (value) => {
      try {
        const url = new URL(String(value || ''), window.location.origin);
        if (url.origin !== window.location.origin || !/\/products\/[^/]+/.test(url.pathname)) return '';
        return `${url.pathname}${url.search}`;
      } catch (error) {
        return '';
      }
    };
    const imageUrl = (value) => {
      try {
        const url = new URL(String(value || ''), window.location.origin);
        const trustedCdn = url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.shopifycdn.com');
        if (url.protocol !== 'https:' && url.origin !== window.location.origin) return '';
        if (url.origin !== window.location.origin && !trustedCdn) return '';
        return url.href;
      } catch (error) {
        return '';
      }
    };
    const sanitize = (entry) => {
      if (!entry || typeof entry !== 'object') return null;
      const handle = text(entry.handle, 255);
      const url = productUrl(entry.url);
      const title = text(entry.title, 300);
      if (!/^[a-z0-9][a-z0-9-]*$/.test(handle) || !url || !title) return null;
      const sourceImage = entry.image && typeof entry.image === 'object' ? entry.image : null;
      const image = sourceImage ? {
        src360: imageUrl(sourceImage.src360),
        src540: imageUrl(sourceImage.src540),
        src720: imageUrl(sourceImage.src720),
        src900: imageUrl(sourceImage.src900),
        alt: text(sourceImage.alt, 300),
        width: Math.min(number(sourceImage.width), 10000),
        height: Math.min(number(sourceImage.height), 10000)
      } : null;
      return {
        handle,
        url,
        title,
        available: entry.available === true,
        price: number(entry.price),
        priceFormatted: text(entry.priceFormatted, 80),
        priceVaries: entry.priceVaries === true,
        compareAtPrice: number(entry.compareAtPrice),
        compareAtPriceFormatted: text(entry.compareAtPriceFormatted, 80),
        image,
        viewedAt: number(entry.viewedAt),
        syncedAt: number(entry.syncedAt)
      };
    };

    const resizedImage = (source, width) => {
      try {
        const url = new URL(String(source || ''), window.location.origin);
        url.searchParams.set('width', String(width));
        return imageUrl(url.href);
      } catch (error) {
        return '';
      }
    };

    const refreshEntry = async (entry) => {
      const freshnessWindow = 6 * 60 * 60 * 1000;
      if (entry.syncedAt > Date.now() - freshnessWindow) return entry;
      try {
        const endpoint = new URL(entry.url, window.location.origin);
        endpoint.search = '';
        endpoint.pathname = `${endpoint.pathname.replace(/\/$/, '')}.js`;
        const response = await fetch(endpoint, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (response.status === 404) return null;
        if (!response.ok) return entry;
        const productData = await response.json();
        const sourceImage = productData.featured_image?.src || productData.featured_image || productData.images?.[0] || '';
        const price = number(productData.price_min ?? productData.price);
        const compareAtPrice = number(productData.compare_at_price_max ?? productData.compare_at_price);
        return sanitize({
          ...entry,
          title: productData.title || entry.title,
          available: productData.available === true,
          price,
          priceFormatted: window.LionTheme?.formatMoney?.(price) || entry.priceFormatted,
          priceVaries: productData.price_varies === true || number(productData.price_min) !== number(productData.price_max),
          compareAtPrice,
          compareAtPriceFormatted: compareAtPrice > price ? (window.LionTheme?.formatMoney?.(compareAtPrice) || entry.compareAtPriceFormatted) : '',
          image: sourceImage ? {
            src360: resizedImage(sourceImage, 360),
            src540: resizedImage(sourceImage, 540),
            src720: resizedImage(sourceImage, 720),
            src900: resizedImage(sourceImage, 900),
            alt: productData.featured_image?.alt || productData.title || entry.title,
            width: number(productData.featured_image?.width),
            height: number(productData.featured_image?.height)
          } : null,
          viewedAt: entry.viewedAt,
          syncedAt: Date.now()
        });
      } catch (error) {
        return entry;
      }
    };
    const storedItems = (root) => {
      try {
        const parsed = JSON.parse(window.localStorage.getItem(root.dataset.storageKey) || '[]');
        const values = Array.isArray(parsed) ? parsed.slice(0, 20) : [];
        const retention = Math.max(1, number(root.dataset.retentionDays)) * 86400000;
        const oldest = Date.now() - retention;
        return values.map(sanitize).filter((entry) => entry && entry.viewedAt >= oldest);
      } catch (error) {
        return [];
      }
    };
    const saveItems = (root, items) => {
      try {
        window.localStorage.setItem(root.dataset.storageKey, JSON.stringify(items));
      } catch (error) {
        return;
      }
    };
    const element = (tag, className, value) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (value) node.textContent = value;
      return node;
    };
    const card = (root, entry) => {
      const article = element('article', 'recent-product-card');
      const media = element('a', 'recent-product-card__media');
      media.href = entry.url;
      media.setAttribute('aria-label', entry.title);
      if (entry.image?.src900) {
        const image = document.createElement('img');
        image.src = entry.image.src720 || entry.image.src900;
        const sources = [
          [entry.image.src360, '360w'],
          [entry.image.src540, '540w'],
          [entry.image.src720, '720w'],
          [entry.image.src900, '900w']
        ].filter(([url]) => Boolean(url));
        if (sources.length > 1) image.srcset = sources.map(([url, width]) => `${url} ${width}`).join(', ');
        image.sizes = '(min-width: 990px) 25vw, (min-width: 750px) 33vw, 76vw';
        image.alt = entry.image.alt || entry.title;
        image.loading = 'lazy';
        image.decoding = 'async';
        if (entry.image.width > 0 && entry.image.height > 0) {
          image.width = entry.image.width;
          image.height = entry.image.height;
        }
        media.append(image);
      } else {
        media.append(element('span', 'recent-product-card__placeholder', entry.title));
      }
      if (!entry.available) media.append(element('span', 'recent-product-card__badge', root.dataset.soldOutLabel));
      else if (entry.compareAtPrice > entry.price) media.append(element('span', 'recent-product-card__badge', root.dataset.saleLabel));

      const content = element('div', 'recent-product-card__content');
      const heading = element('h3', 'recent-product-card__title');
      const titleLink = element('a', '', entry.title);
      titleLink.href = entry.url;
      heading.append(titleLink);
      const price = element('p', 'recent-product-card__price');
      const priceText = `${entry.priceVaries ? `${root.dataset.fromLabel} ` : ''}${entry.priceFormatted}`.trim();
      price.append(element('span', 'recent-product-card__price-current', priceText));
      if (entry.compareAtPrice > entry.price && entry.compareAtPriceFormatted) {
        price.append(element('s', 'recent-product-card__price-compare', entry.compareAtPriceFormatted));
      }
      content.append(heading, price);
      article.append(media, content);
      return article;
    };
    const initialize = async (root) => {
      if (root.dataset.recentlyViewedReady === 'true') return;
      root.dataset.recentlyViewedReady = 'true';
      const data = root.querySelector('[data-recently-viewed-current]');
      const grid = root.querySelector('[data-recently-viewed-grid]');
      if (!data || !grid) return;
      let current;
      try {
        current = sanitize(JSON.parse(data.textContent));
      } catch (error) {
        current = null;
      }
      if (!current) return;

      const historySize = Math.min(Math.max(2, number(root.dataset.historySize)), 20);
      const limit = Math.min(Math.max(1, number(root.dataset.limit)), historySize);
      const history = storedItems(root).filter((entry) => entry.handle !== current.handle);
      const candidates = history.slice(0, limit);
      const refreshed = await Promise.all(candidates.map(refreshEntry));
      const visible = refreshed.filter(Boolean);
      if (visible.length > 0) {
        const fragment = document.createDocumentFragment();
        visible.forEach((entry) => fragment.append(card(root, entry)));
        grid.replaceChildren(fragment);
        if (root.dataset.mobileLayout === 'carousel') grid.tabIndex = 0;
        root.querySelector('[data-recently-viewed-note]')?.remove();
        root.hidden = false;
      } else if (window.Shopify?.designMode) {
        root.hidden = false;
      } else {
        grid.replaceChildren();
        root.hidden = true;
      }
      delete root.dataset.recentlyViewedReserved;
      root.removeAttribute('aria-busy');

      current.viewedAt = Date.now();
      current.syncedAt = Date.now();
      const refreshedByHandle = new Map(candidates.map((entry, index) => [entry.handle, refreshed[index]]));
      const refreshedHistory = history.map((entry) => refreshedByHandle.has(entry.handle) ? refreshedByHandle.get(entry.handle) : entry).filter(Boolean);
      const next = [current, ...refreshedHistory].slice(0, historySize);
      saveItems(root, next);
    };
    const initializeWithin = (scope = document) => {
      const roots = [];
      if (scope instanceof Element && scope.matches('[data-recently-viewed]')) roots.push(scope);
      scope.querySelectorAll?.('[data-recently-viewed]').forEach((root) => roots.push(root));
      roots.forEach(initialize);
    };

    initializeWithin();
    document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loadRecommendations = async (root) => {
      if (root.dataset.loaded === 'true' || root.dataset.loading === 'true') return;
      root.dataset.loading = 'true';
      try {
        const response = await fetch(root.dataset.url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error(String(response.status));
        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = documentFragment.querySelector('[data-product-recommendations]');
        if (!incoming) throw new Error('recommendations');
        root.innerHTML = incoming.innerHTML;
        root.dataset.loaded = 'true';
        root.dataset.hasProducts = incoming.dataset.hasProducts;
        root.hidden = incoming.dataset.hasProducts !== 'true';
        window.LionTheme?.initialize(root);
      } catch (error) {
        root.hidden = true;
      } finally {
        delete root.dataset.loading;
      }
    };

    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-product-recommendations][data-loaded="false"]:not([data-observed])').forEach((root) => {
        root.dataset.observed = 'true';
        if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {
          loadRecommendations(root);
          return;
        }
        const observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          loadRecommendations(root);
        }, { rootMargin: '0px 0px 300px 0px' });
        observer.observe(root);
      });
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews-hub"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('review-story-carousel')) {
    customElements.define('review-story-carousel', class ReviewStoryCarousel extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-review-slide]'));
        this.navigationItems = Array.from(this.querySelectorAll('[data-review-navigation-item]'));
        this.currentOutput = this.querySelector('[data-review-current]');
        this.previousButton = this.querySelector('[data-review-previous]');
        this.nextButton = this.querySelector('[data-review-next]');
        this.navigation = this.querySelector('[data-review-navigation]');
        this.currentIndex = Math.max(0, this.slides.findIndex((slide) => !slide.hidden));
        this.touchStartX = 0;
        this.previousButton?.addEventListener('click', () => this.show(this.currentIndex - 1));
        this.nextButton?.addEventListener('click', () => this.show(this.currentIndex + 1));
        this.navigationItems.forEach((item, index) => {
          item.addEventListener('click', () => this.show(index));
          item.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowLeft') { event.preventDefault(); this.show(index - 1, true); }
            if (event.key === 'ArrowRight') { event.preventDefault(); this.show(index + 1, true); }
          });
        });
        this.addEventListener('touchstart', (event) => { this.touchStartX = event.changedTouches[0]?.clientX || 0; }, { passive: true });
        this.addEventListener('touchend', (event) => {
          const touchEndX = event.changedTouches[0]?.clientX || 0;
          const distance = touchEndX - this.touchStartX;
          if (Math.abs(distance) < 48) return;
          this.show(this.currentIndex + (distance < 0 ? 1 : -1));
        }, { passive: true });
      }
      show(requestedIndex, focusNavigation = false) {
        if (this.slides.length < 2) return;
        const nextIndex = (requestedIndex + this.slides.length) % this.slides.length;
        if (nextIndex === this.currentIndex) return;
        const currentSlide = this.slides[this.currentIndex];
        const nextSlide = this.slides[nextIndex];
        currentSlide.hidden = true;
        currentSlide.classList.remove('is-active');
        currentSlide.setAttribute('aria-hidden', 'true');
        nextSlide.hidden = false;
        nextSlide.classList.add('is-active');
        nextSlide.setAttribute('aria-hidden', 'false');
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          nextSlide.animate([{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 360, easing: 'cubic-bezier(.2,.7,.2,1)' });
        }
        this.navigationItems.forEach((item, index) => {
          const selected = index === nextIndex;
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.setAttribute('tabindex', selected ? '0' : '-1');
        });
        if (this.currentOutput) this.currentOutput.textContent = String(nextIndex + 1).padStart(2, '0');
        this.currentIndex = nextIndex;
        const selectedNavigation = this.navigationItems[nextIndex];
        if (selectedNavigation && this.navigation) {
          const left = selectedNavigation.offsetLeft - ((this.navigation.clientWidth - selectedNavigation.offsetWidth) / 2);
          this.navigation.scrollTo({ left, behavior: 'smooth' });
          if (focusNavigation) selectedNavigation.focus();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-size-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.sizeGuideReady === 'true') return;
      const track = root.querySelector('[data-size-guide-track]');
      const controls = root.querySelector('[data-size-guide-controls]');
      if (!track || !controls) return;
      const previous = controls.querySelector('[data-size-guide-previous]');
      const next = controls.querySelector('[data-size-guide-next]');
      const current = controls.querySelector('[data-size-guide-current]');
      const total = controls.querySelector('[data-size-guide-total]');
      const progress = controls.querySelector('[data-size-guide-progress]');
      if (!previous || !next || !current || !total || !progress) return;
      root.dataset.sizeGuideReady = 'true';
      const visibleItems = () => Array.from(track.querySelectorAll('[data-size-guide-item]')).filter((item) => item.offsetParent !== null);
      const activeIndex = (items) => {
        const styles = getComputedStyle(track);
        const start = track.getBoundingClientRect().left + (parseFloat(styles.paddingInlineStart) || 0);
        return items.reduce((best, item, index) => Math.abs(item.getBoundingClientRect().left - start) < best.distance ? { index, distance: Math.abs(item.getBoundingClientRect().left - start) } : best, { index: 0, distance: Infinity }).index;
      };
      const update = () => {
        const items = visibleItems();
        if (!items.length) return;
        const index = activeIndex(items);
        current.textContent = String(index + 1);
        total.textContent = String(items.length);
        progress.style.width = `${((index + 1) / items.length) * 100}%`;
        previous.disabled = index === 0;
        next.disabled = index === items.length - 1;
      };
      const move = (direction) => {
        const items = visibleItems();
        if (!items.length) return;
        const index = Math.min(Math.max(activeIndex(items) + direction, 0), items.length - 1);
        const padding = parseFloat(getComputedStyle(track).paddingInlineStart) || 0;
        track.scrollTo({ left: items[index].offsetLeft - padding, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      let frame;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(update);
      }, { passive: true });
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      requestAnimationFrame(update);
    };
    const initializeAll = (scope = document) => scope.querySelectorAll('[data-size-guide]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    else initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const activateTab = (root, tab, moveFocus = false) => {
      const panelId = tab.getAttribute('aria-controls');
      root.querySelectorAll('[data-product-tab]').forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.tabIndex = active ? 0 : -1;
      });
      root.querySelectorAll('[data-product-tab-panel]').forEach((panel) => {
        panel.hidden = panel.id !== panelId;
      });
      if (moveFocus) tab.focus();
    };

    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-product-tabs]:not([data-product-tabs-ready])').forEach((root) => {
        root.dataset.productTabsReady = 'true';
      });
    };

    document.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-product-tab]');
      if (!tab) return;
      const root = tab.closest('[data-product-tabs]');
      if (root) activateTab(root, tab);
    });

    document.addEventListener('keydown', (event) => {
      const tab = event.target.closest('[data-product-tab]');
      if (!tab) return;
      const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (!keys.includes(event.key)) return;
      const root = tab.closest('[data-product-tabs]');
      const tabs = Array.from(root.querySelectorAll('[data-product-tab]'));
      const current = tabs.indexOf(tab);
      let next = current;
      if (event.key === 'ArrowRight') next = (current + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      event.preventDefault();
      activateTab(root, tabs[next], true);
    });

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const panel = event.target.closest('[data-product-tab-block]');
      if (!panel) return;
      const root = panel.closest('[data-product-tabs]');
      const tab = Array.from(root.querySelectorAll('[data-product-tab]')).find((item) => item.dataset.blockId === panel.dataset.productTabBlock);
      if (tab) activateTab(root, tab);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
    else initialize();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindVideoEditorial = (scope) => {
      scope.querySelectorAll('[data-video-editorial]').forEach((section) => {
        if (section.dataset.videoEditorialBound === 'true') return;
        section.dataset.videoEditorialBound = 'true';
        const trigger = section.querySelector('[data-video-editorial-play]');
        const toggle = section.querySelector('[data-video-editorial-toggle]');
        const video = section.querySelector('video');
        const iframe = section.querySelector('iframe');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduceMotion && video) {
          video.autoplay = false;
          video.pause();
        }
        if (reduceMotion && iframe) {
          const source = new URL(iframe.src, window.location.href);
          source.searchParams.set('autoplay', '0');
          iframe.src = source.toString();
        }
        if (trigger) trigger.addEventListener('click', () => {
          trigger.hidden = true;
          if (video) video.play().catch(() => { trigger.hidden = false; });
          if (iframe) {
            const source = new URL(iframe.src, window.location.href);
            source.searchParams.set('autoplay', '1');
            if (section.dataset.videoMuted === 'true') {
              source.searchParams.set('mute', '1');
              source.searchParams.set('muted', '1');
            }
            iframe.src = source.toString();
          }
        });
        if (toggle && video) {
          const icon = toggle.querySelector('[data-video-editorial-toggle-icon]');
          const syncToggle = () => {
            const isPaused = video.paused;
            toggle.setAttribute('aria-label', isPaused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
            if (icon) icon.textContent = isPaused ? '▶' : 'Ⅱ';
          };
          toggle.addEventListener('click', () => {
            if (video.paused) video.play().catch(() => {});
            else video.pause();
          });
          video.addEventListener('play', syncToggle);
          video.addEventListener('pause', syncToggle);
          syncToggle();
        }
      });
    };
    bindVideoEditorial(document);
    document.addEventListener('shopify:section:load', (event) => bindVideoEditorial(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
